/**
 * Përkthimet Shqip / English – krejt tekstit e aplikacionit
 */
export const translations = {
  sq: {
    // Layout & Nav (ekzistojnë)
    logout: 'Dil',
    tgSeeded: '{n} tag u seed-uan nga {profile}',
    tgThresholdsToast: 'Pragje: {name}',
    tgThresholdsErr: 'Pragjet: {detail}',
    tgEnableReads: 'Aktivizo leximesh',
    tgApplyFieldSafe: 'Apliko field-safe',
    tgAlarmThresholds: 'Pragje alarmi',
    egDraftCreated: 'Draft u krijua ({id})',
    egSkipped: 'Sync anashkaloi pajisjet pa tag enabled: {keys}',
    egPublished: 'Draft + publish u kryen (Sync edge)',
    egDraftEdge: 'Draft edge u krijua',
    egQueue: 'Radha',
    egQueueTitle: 'Radha edge',
    egBatch: 'batch',
    ddTime: 'Koha',
    ddPlantProduction: 'Prodhimi i impiantit',
    ddLogger: 'Regjistruesi',
    ddReactivePower: 'Fuqia reaktive',
    ddPowerFactor: 'Faktori i fuqisë',
    ddEnergyToday: 'Energjia sot',
    ddEnergyTotal: 'Energjia totale',
    ddCapacity: 'Kapaciteti',
    ddAlarmHistory: 'Historiku i alarmeve',
    ddInverterPrefix: 'Inverter',
    ddOpen: 'HAP →',
    ddEnergyAnalysis: 'Analiza e Energjisë',
    ddActualLoad: 'Ngarkimi aktual',
    ddNoComm: 'Pa komunikim',
    ddKpiActivePower: 'FUQIA AKTIVE',
    ddKpiToday: 'SOT',
    ddKpiRatedAc: 'AC NOMINALE',
    ddKpiActiveAlarms: 'ALARME AKTIVE',
    ddCommunication: 'Komunikimi',
    ddPhoto: 'Foto',
    ddUploadPhoto: 'Ngarko Foto',
    ddErrPhoto: 'Gabim gjatë ngarkimit të fotos',
    ddHistory: 'Historiku',
    ddEnergy: 'Energjia',
    ddNeutral: 'Neutral',
    ddPrevious: 'Para',
    ddNext: 'Pas',
    ddPeriod_day: 'Dita',
    ddPeriod_week: 'Java',
    ddPeriod_month: 'Muaji',
    ddPeriod_year: 'Viti',
    ddPeriod_lifetime: 'Gjithë kohës',
    ddParamsEyebrow: 'PROXNOVA / PARAMETRAT',
    ddParamsTitle: 'Parametra të detajuar',
    ddNoLiveTelemetry: 'Nuk ka ende telemetri live — po shfaqen vlera provizore.',
    ddReadingsFromDevice: 'Lexime nga pajisja (live / historian).',
    tgTitle: 'Matjet Modbus',
    tgActiveCount: 'aktive',
    tgAddTag: '+ Tag',
    tgCancel: 'Anulo',
    tgEnableAllTitle: 'Aktivizo të gjitha regjistrat e leximit (holding/input); coil mbeten off',
    tgFieldSafeTitle: 'Vetëm tag-et e verifikuara në field (min profile)',
    tgNoTagsSeed: 'Nuk ka tag — edge nuk e pollohet këtë pajisje derisa të seed-ohen nga driver profile.',
    tgPickProfile: 'Zgjidh profil…',
    tgActiveRead: 'Aktiv (lexohet nga edge)',
    tgAlarmHint: 'Krijon alarm kur vlera del jashtë intervalit',
    tgLowThreshold: 'Pragu i ulët',
    tgHighThreshold: 'Pragu i lartë',
    tgLowTitle: 'Vlera minimale — nën këtë shkakton alarm',
    tgHighTitle: 'Vlera maksimale — mbi këtë shkakton alarm',
    tgSaveTag: 'Ruaj tag',
    tgLoading: 'Duke ngarkuar…',
    tgNoTags: 'Nuk ka tag për këtë pajisje.',
    tgThresholds: 'Pragje',
    tgClose: 'Mbyll',
    tgDisableTitle: 'Çaktivizo (hiq nga edge)',
    tgEnableTitle: 'Aktivizo (shto në edge)',
    tgSaveThresholds: 'Ruaj pragjet',
    tgErrToggle: 'Toggle dështoi: {detail}',
    tgErrEnableAll: 'Aktivizo leximesh dështoi: {detail}',
    tgErrFieldSafe: 'Field-safe dështoi: {detail}',
    tgErrPickProfile: 'Zgjidh driver profile për seed',
    tgErrSeed: 'Seed dështoi: {detail}',
    tgErrNameAddr: 'Emri dhe adresa janë të detyrueshme',
    tgErrAdd: 'Shtimi dështoi: {detail}',
    egErrDraft: 'Draft dështoi: {detail}',
    egErrPublish: 'Publish dështoi: {detail}',
    egHealed: 'Tagët u riparuan: {tags}',
    egPublishDisabled: 'Publish i çaktivizuar në API',
    egErrSync: 'Sync edge dështoi: {detail}',
    egOneStep: 'Draft + publish në një hap',
    egClose: 'Mbyll',
    egQuotaFull: 'kuota e plotë',
    egQuotaWarn: 'paralajmërim kuote',
    egAgo: '{age} më parë',
    egHint: 'Publish → MQTT desired. Aktivizimi në edge kërkon EDGE_AGENT_CONFIG_APPLY_ENABLE=true.',
    dpAllStatuses: 'Të gjitha statuset',
    dpSearchPlaceholder: 'Kërko pajisjen ose serialin…',
    dpSearchAria: 'Kërko pajisjet',
    dpStatusFilterAria: 'Filtro statusin',
    dpColStatus: 'STATUSI',
    dpColDevice: 'PAJISJA',
    dpColType: 'TIPI',
    dpColPower: 'FUQIA',
    dpColActions: 'VEPRIMET',
    dpLblStatus: 'Statusi',
    dpLblDevice: 'Pajisja',
    dpLblType: 'Tipi',
    dpLblPower: 'Fuqia',
    dpLblActions: 'Veprimet',
    dpAutoProfile: 'Auto nga brand/model',
    dpTags: 'tag',
    dpProfileHint: 'Ndryshimi Huawei ↔ Sungrow (etj.) në Ruaj ri-seed-on tagët dhe e dërgon te Pi. Lista e tagëve: më poshtë te “Tags Modbus”.',
    dpIpPlaceholderChint: '0.0.0.0 ose etiketë',
    dpBulkLogger: 'Krijo automatikisht inv-001…inv-N (COM unit të ndryshëm)',
    dpBulkInverter: 'Krijo shumë inverter (COM unit 1…N)',
    dpUnitFrom: 'Unit nga',
    dpUnitTo: 'Unit deri',
    dpTransform: 'Transform',
    dpTransformHint: 'Shkallëzon kWh total përpara/mbrapa të Chint para ruajtjes. Parazgjedhja 1.',
    dpSchemeCommNote: 'Komunikim, jo energji',
    dpSchemeFooter: 'Nuk është projekt elektrik për instalim.',
    dpEmptyHint: 'Provo një emër tjetër ose ndrysho filtrin e statusit.',
    dpErrNetwork: 'Lidhja me serverin dështoi. Kontrolloni që backend-i të jetë i ndezur.',
    dpErrDelete: 'Gabim gjatë fshirjes',
    dpPickCompany: 'Zgjidh një kompani!',
    dpPickLogger: 'Zgjidh Data Logger!',
    dpTagsReseeded: '{n} tag u ri-seed-uan ({profile})',
    dpInvertersCreated: '{n} inverter u krijuan ({skipped} ekzistues)',
    dpInvertersCreatedRange: '{n} inverter u krijuan ({from}…{to})',
    dpTagsSeeded: '{n} tag Modbus u seed-uan',
    dpTagsSeededInverters: '{n} tag Modbus u seed-uan për inverterët',
    dpTagsLoaded: '{n} tag u ngarkuan nga driver profile',
    dpEdgeSent: 'Konfigurimi u dërgua te edge-agent',
    dpEdgeDraft: 'Draft edge config; publish i çaktivizuar në API',
    dpPhoto401: 'Foto: nuk je i kyçur ose token i skaduar. Dil dhe kyçu përsëri.',
    dpPhoto404: 'Foto: endpoint ose pajisja nuk u gjet. Kontrollo që backend-i është i përditësuar (nisje përsëri).',
    dpPhoto405: 'Foto: Method Not Allowed. Backend-i duhet rinovuar (mbyll dhe nis përsëri serverin).',
    dpPhoto500: 'Foto: gabim serveri: {detail}',
    dpPhotoFail: 'Foto nuk u ruajt ({status}): {detail}',
    dpNetwork: 'rrjet',
    dpUpdated: 'Pajisja u përditësua!',
    dpAdded: 'Pajisja u shtua!',
    dpError: 'Gabim',
    dvPreviewTitle: 'Matjet e pajisjes',
    dvPreviewEyebrow: 'MATJET E PAJISJES',
    dvCloseDetails: 'Mbyll detajet',
    dvFullDetails: 'Detajet e plota',
    dvRowCompany: 'Kompania',
    dvRowType: 'Lloji',
    dvRowBrand: 'Brendi',
    dvRowModel: 'Modeli',
    dvRowSerial: 'Seriali',
    dvRowStatus: 'Statusi',
    dvRowPower: 'Fuqia aktive',
    dvEmptyHint: 'Provo një emër tjetër ose ndrysho filtrin e statusit.',
    dvUnitIdInUse: 'Ky Unit ID është tashmë në përdorim te ky Data Logger.',
    monLiveTitle: 'Monitorimi Live i Impianteve Solare',
    monLiveTitleCompany: 'Monitorimi Live · {name}',
    noPermission: 'Nuk lejohet',
    settings: 'Cilësimet',
    reportNeedDates: 'Cakto fillimin dhe fundin.',
    reportGenerateFirst: 'Gjenero raportin para se ta shkarkosh.',
    popupBlocked: 'Lejo dritaren e re për PDF.',
    pdfReady: 'PDF u gjenerua me sukses.',
    rvNoData: 'Nuk ka të dhëna të mjaftueshme.',
    rvChartDays: 'Prodhimi për ditë',
    rvChartYear: 'Ky vit dhe viti i kaluar',
    rvLegendYear: 'cyan ky vit · blu viti i kaluar',
    rvFlowBalance: 'Bilanci i flukseve',
    rvChartHourly: 'Prodhimi sipas orës',
    rvLegendTomorrow: 'kWh · nesër',
    rvChartPower: 'Fuqia gjatë ditës',
    rvLegendHour: 'kW · orë',
    rvInverters: 'Inverterët',
    rvNr: 'Nr',
    rvMonth_0: 'Jan',
    rvMonth_1: 'Shk',
    rvMonth_2: 'Mar',
    rvMonth_3: 'Pri',
    rvMonth_4: 'Maj',
    rvMonth_5: 'Qer',
    rvMonth_6: 'Kor',
    rvMonth_7: 'Gus',
    rvMonth_8: 'Sht',
    rvMonth_9: 'Tet',
    rvMonth_10: 'Nën',
    rvMonth_11: 'Dhj',
    abSummary: 'ProxNova SCADA është platformë industriale për monitorimin, automatizimin dhe menaxhimin e proceseve në kohë reale. Platforma mundëson integrimin e inverterëve, PLC-ve, Data Logger-ëve, matësve të energjisë, sensorëve dhe sistemeve industriale në një mjedis të centralizuar.',
    abMobileSummary: 'Platformë industriale për monitorimin, kontrollin dhe menaxhimin në kohë reale të sistemeve energjetike dhe industriale.',
    abDoc_brochure_title: 'Broshura ProxNova SCADA 2026',
    abDoc_brochure_text: 'Prezantimi i platformës dhe moduleve.',
    abDoc_manual_title: 'Manuali i përdorimit',
    abDoc_manual_text: 'Përdorimi i moduleve.',
    abDoc_install_title: 'Udhëzuesi i instalimit',
    abDoc_install_text: 'Instalimi dhe nisja.',
    abDoc_tech_title: 'Dokumentacioni teknik',
    abDoc_tech_text: 'Arkitektura dhe integrimet.',
    abDoc_notes_title: 'Shënimet e versioneve',
    abDoc_notes_text: 'Përmbledhje e publikimeve.',
    'abVer_2.3_note': 'Paketa e plotë e ndërfaqes aktuale.',
    'abVer_2.2_g0_title': 'Përmirësime të dizajnit',
    'abVer_2.2_g0_i0_title': 'Popup-et',
    'abVer_2.2_g0_i0_text': 'Sfondi pas dialogëve është i turbullt, njësoj në desktop dhe në mobile.',
    'abVer_2.2_g0_i1_title': 'Shto Pajisje',
    'abVer_2.2_g0_i1_text': 'Në mobile dialogu qëndron në mes të ekranit.',
    'abVer_2.0_g0_title': 'Funksione të reja',
    'abVer_2.0_g0_i0_title': 'Raportet',
    'abVer_2.0_g0_i0_text': 'Prodhimi, financa, analiza, bateritë, raportet teknike dhe ekzekutive, me pamje paraprake dhe PDF.',
    'abVer_2.0_g0_i1_title': 'Konfigurimi financiar',
    'abVer_2.0_g0_i1_text': 'Investimi, kreditë, tarifat dhe llogaritja nga vlerat e futura.',
    'abVer_2.0_g0_i2_title': 'Planifikimi',
    'abVer_2.0_g0_i2_text': 'Krahasimi orë për orë dhe dokumenti i parashikimit.',
    'abVer_2.0_g0_i3_title': 'Alarmet',
    'abVer_2.0_g0_i3_text': 'Alarmet aktive, historiku dhe njoftimet.',
    'abVer_2.0_g0_i4_title': 'Burimet dhe mbështetja',
    'abVer_2.0_g0_i4_text': 'Dokumentacioni dhe manualet.',
    'abVer_2.0_g1_title': 'Përmirësime',
    'abVer_2.0_g1_i0_title': 'Kompania në krye',
    'abVer_2.0_g1_i0_text': 'Zgjedhja e kompanisë filtron faqen e hapur.',
    'abVer_2.0_g1_i1_title': 'Pamja',
    'abVer_2.0_g1_i1_text': 'Tema e errët dhe e çelët në portal.',
    'abVer_2.0_g2_title': 'Përmirësime të dizajnit',
    'abVer_2.0_g2_i0_title': 'Dokumentet',
    'abVer_2.0_g2_i0_text': 'Raportet përdorin të njëjtin dokument në ekran dhe në PDF.',
    'abVer_2.0_g2_i1_title': 'Llogaria',
    'abVer_2.0_g2_i1_text': 'Menyja e llogarisë është e organizuar sipas grupeve.',
    'abVer_1.02_note': 'Nuk ka shënime të publikuara për këtë version.',
    abDocsTitle: 'Dokumentacioni & Shkarkimet',
    abNotLoaded: 'Dokumenti nuk është ngarkuar ende',
    abViewDoc: 'Shiko dokumentin',
    abDownloadPdf: 'Shkarko PDF',
    abWhatsNew: 'Çfarë ka të re?',
    abVersionHistory: 'Historiku i versioneve',
    abContactSupport: 'Kontakt & Mbështetje',
    abVersionsUpdates: 'Versionet dhe përditësimet',
    abDocuments: 'Dokumentet',
    abContactSupportM: 'Kontakt dhe mbështetje',
    abDeveloper: 'Zhvilluesi',
    abPlatform: 'Platforma',
    abPhone: 'Telefoni',
    abPhoneShort: 'Telefon',
    asTitle: 'Dërgimet automatike',
    asSubtitle: 'Konfiguro raportet periodike me email',
    asAdminOnly: 'Vetëm administruesi konfigurón dërgimet automatike.',
    asAdminOnlySave: 'Vetëm administruesi ruan dërgimet.',
    asPickFreq: 'Zgjidh të paktën një frekuencë.',
    asPickWeekday: 'Zgjidh ditën e javës.',
    asPickMonthday: 'Zgjidh ditën e muajit.',
    asPickRecipient: 'Zgjidh të paktën një marrës.',
    asDuplicate: 'Ky dërgim ekziston dhe nuk u shtua përsëri.',
    asActivated: 'Dërgimi u aktivizua.',
    asDeactivated: 'Dërgimi u çaktivizua.',
    asConfirmRemove: 'Ky dërgim hiqet nga lista.',
    asChangesSaved: 'Ndryshimet u ruajtën me sukses.',
    asConfigTitle: 'Konfigurimi i dërgimit',
    asFrequency: 'Frekuenca',
    asDaily: 'Ditore',
    asWeekly: 'Javore',
    asMonthly: 'Mujore',
    asWeekday: 'Dita e javës',
    asPickDay: 'Zgjidh ditën',
    asMonthday: 'Dita e muajit',
    asSendTime: 'Ora e dërgimit',
    asTimezone: 'Zona kohore',
    asRecipientsTitle: 'Marrësit e raportit',
    asSelected: 'të zgjedhur',
    asNoUsers: 'Nuk ka përdorues për këtë kompani.',
    asSaveSchedule: 'Ruaj dërgimin',
    asConfigured: 'Dërgimet e konfiguruara',
    asNone: 'Nuk ka dërgime të ruajtura.',
    asColReport: 'Raporti',
    asColHour: 'Ora',
    asColRecipients: 'Marrësit',
    asHint: 'Orari ruhet lokalisht (si V2). Dërgimi real me email aktivizohet kur serveri ka `report_schedules` + SMTP — konfigurimi mbetet i njëjtë.',
    asDay_1: 'E hënë',
    asDay_2: 'E martë',
    asDay_3: 'E mërkurë',
    asDay_4: 'E enjte',
    asDay_5: 'E premte',
    asDay_6: 'E shtunë',
    asDay_7: 'E diel',
    finTitle: 'Konfigurimi financiar',
    finSubtitle: 'Parametrat financiarë të impiantit',
    finNoPermission: 'Nuk ke leje për konfigurimin financiar.',
    finNoPermissionEdit: 'Nuk ke leje të ndryshosh konfigurimin financiar.',
    finPickCompany: 'Zgjidh një kompani.',
    finTariffNeedsDate: 'Tarifa e re kërkon datën e fillimit.',
    finInvoiceNeedsMonth: 'Fatura e re kërkon muajin.',
    finNotSaved: 'Konfigurimi nuk u ruajt.',
    finSyncFailed: 'Financa u ruajt lokalisht; sync i tarifës te API dështoi (shiko lejet/token).',
    finSaved: 'Konfigurimi u ruajt.',
    finNetInvestment: 'Investimi neto (€)',
    finAfterSubsidy: 'Pas subvencioneve',
    finLoanFinancing: 'Financimi me kredi (€)',
    finLoanSum: 'Shuma e kredive',
    finCapacityInstalled: 'Kapaciteti i instaluar (kWp)',
    finFromSaved: 'Nga vlera e ruajtur',
    finAccInvest: 'Investimi',
    finAccInvestSub: 'Panelet, inverterët, instalimi, bateritë, subvencionet',
    finPanels: 'Panelet',
    finInverters: 'Inverterët',
    finInstall: 'Instalimi',
    finBattery: 'Bateria',
    finOther: 'Të tjera',
    finSubsidy: 'Subvencione',
    finTotalInvestment: 'Totali i investimit',
    finTotalHint: 'Panelet + inverterët + instalimi + bateria + të tjera',
    finCapacityKwp: 'Kapaciteti (kWp)',
    finInvestedOn: 'Data e investimit',
    finOperatedOn: 'Fillimi i operimit',
    finHasBattery: 'Ka bateri të konfiguruara',
    finBatKwh: 'Kapaciteti (kWh)',
    finBatPower: 'Fuqia (kW)',
    finBatChem: 'Kimia e baterisë',
    finAccLoan: 'Kreditë dhe financimi',
    finAccLoanSub: 'Kredia, interesi, kësti, afati dhe pagesat',
    finLoanAmount: 'Shuma',
    finLoanBank: 'Banka',
    finLoanRate: 'Norma',
    finLoanTerm: 'Afati',
    finMonths: 'muaj',
    finLoanInstallment: 'Kësti mujor',
    finLoanStart: 'Fillimi',
    finLoanPaidCount: 'Këste të paguara',
    finLoanPaidPrincipal: 'Principali i paguar',
    finLoanExtra: 'Pagesa shtesë',
    finLoanStatus: 'Statusi',
    finRemove: 'Hiq',
    finAddLoan: 'Shto kredi',
    finAccTariff: 'Tarifat e energjisë',
    finAccTariffSub: 'Importi, eksporti, tarifat ditë/natë',
    finTariffLine: '{from} · blerja {import} · eksporti {export}',
    finNoTariffs: 'Nuk ka tarifa.',
    finTDate: 'Data',
    finTBuy: 'Blerja',
    finTExport: 'Eksporti',
    finTDay: 'Ditë',
    finTNight: 'Natë',
    finTPeak: 'Piku',
    finTFixed: 'Fikse',
    finTScheme: 'Skema',
    finTariffHint: 'Tarifa e re shtohet në listë kur ruan. Tarifa aktive = e fundit me datë ≤ sot. Blerja sync-ohet te API `tariff_eur_per_kwh` për profitin e panelit.',
    finAccInvoice: 'Faturat mujore',
    finAccInvoiceSub: 'Faturat reale dhe shpenzimet e energjisë',
    finColMonth: 'Muaji',
    finColEnergy: 'Energjia',
    finColTotal: 'Totali',
    finColPaid: 'Paguar',
    finColActions: 'Veprime',
    finNoInvoices: 'Nuk ka fatura.',
    finDelete: 'Fshi',
    finITaxes: 'Taksa',
    finICredit: 'Kreditimi',
    finIPaidOn: 'Data e pagesës',
    finIRef: 'Referenca',
    finAccAnalysis: 'Analiza financiare',
    finAccAnalysisSub: 'Kursimet dhe rrjedha nga vlerat e futura',
    finPvProduction: 'Prodhimi PV',
    finSelfConsumption: 'Vetëkonsumi',
    finExport: 'Eksporti',
    finImport: 'Importi',
    finOpex: 'Shpenzime operative',
    finDiscount: 'Norma e skontimit',
    finAnnualFlows: 'Flukset vjetore',
    finKpiSavings: 'Kursimi',
    finKpiExport: 'Eksporti',
    finKpiOperating: 'Përfitimi operativ',
    finKpiAfterInstallment: 'Pas këstit',
    finKpiPayback: 'Kthimi i investimit',
    finYears: 'vjet',
    finMissing: 'Mungon: {items}.',
    finMiss_tarifat: 'tarifat',
    finMiss_energjia: 'energjia',
    'finMiss_shpenzimet operative': 'shpenzimet operative',
    finFormula: 'Formula: kursimi = vetëkonsumi × tarifa e blerjes; eksporti € = kWh e eksportuar × tarifa e eksportit; operativ = kursimi + eksporti € − opex; cash = operativ − kësti (nëse ka kredi).',
    finNoAudit: 'Nuk ka ndryshime të ruajtura.',
    finAuditLine: 'versioni',
    finDirty: 'Ka ndryshime të paruajtura.',
    finSave: 'Ruaj konfigurimin',
    finSaving: 'Duke ruajtur…',
    finImpactTitle0: 'Tarifa e blerjes (€/kWh)',
    finImpactText0: 'Kursimi = vetëkonsumi (kWh) × tarifa e blerjes. Është kostoja e shmangur e energjisë nga rrjeti.',
    finImpactTitle1: 'Tarifa e eksportit (€/kWh)',
    finImpactText1: 'Përfitimi nga eksporti = kWh e eksportuar × tarifa e eksportit. Nuk numërohet dy herë me kursimin.',
    finImpactTitle2: 'Prodhimi PV',
    finImpactText2: 'Nuk trajtohet si fitim i drejtpërdrejtë. Shërben për bilanc dhe raporte prodhimi; fitimi vjen nga vetëkonsumi + eksporti.',
    finImpactTitle3: 'OPEX',
    finImpactText3: 'Zbritet nga (kursimi + eksporti €) për të dhënë përfitimin operativ.',
    finImpactTitle4: 'Kësti i kredisë',
    finImpactText4: 'Zbritet një herë nga përfitimi operativ → rrjedha pas këstit. Pa kredi, cash = operativ.',
    finImpactTitle5: 'Investimi / subvencioni',
    finImpactText5: 'Neto = bruto − subvencione. Përdoret për kthimin e investimit (vjet) = investimi / përfitimi operativ.',
    finImpactTitle6: 'Kapaciteti (kWp) & bateria',
    finImpactText6: 'kWp: meta e impiantit. hasBattery hap raportet B; pa flamur, raportet e baterisë nuk trillojnë pajisje.',
    finImpactTitle7: 'Faturat',
    finImpactText7: 'Kreditimi i faturuar dhe pagesat e arkëtuara për raportet F — të ndara nga llogaritja operative e tarifave.',
    usRolesTitle: 'Rolet dhe privilegjet',
    usReadOnly: 'vetëm lexim',
    usEditRole: 'Ndrysho rolin',
    usNewRoleTitle: 'Rol i ri',
    usRoleName: 'Emri',
    usPermissions: 'Lejet',
    usRoleNoEdit: 'Rolet e platformës nuk mund të ndryshohen',
    usRoleNoDelete: 'Rolet e platformës nuk mund të fshihen',
    usRoleSaved: 'Roli u ruajt',
    usRoleSaveFail: 'Ruajtja e rolit dështoi',
    usRoleDeleteTitle: 'Fshi rolin',
    usRoleDeleteMsg: 'Të fshihet roli "{name}"? Përdoruesit me vetëm këtë rol mund të humbin qasjen.',
    usRoleDeleted: 'Roli u fshi',
    usDeleteFail: 'Fshirja dështoi',
    mdPasswordIdp1: 'Fjalëkalimet menaxhohen nga identity provider (SSO / oidc-lab). Platform API nuk ruan kredencialet.',
    mdPasswordIdp2: 'Përdor cilësimet e llogarisë në IdP për ndryshim.',
    mdSettingsNote: 'Gjuha, pamja dhe siguria',
    mdAboutNote: 'Versioni dhe kontakti',
    mdLogoutNote: 'Mbyll sesionin',
    cnKicker: 'PROXNOVA / ADMINISTRIM',
    cnSearchPlaceholder: 'Kërko gateway / site / pajisje',
    cnSearchAria: 'Kërko lidhjet',
    cnAdd: 'Shto gateway',
    cnEdit: 'Edito',
    cnColSync: 'Sinkronizimi',
    cnFormEdit: 'Edito gateway',
    cnClose: 'Mbyll',
    cnFormHint: 'Një kuti (Raspberry) për gateway. Të gjitha përdorin të njëjtin broker MQTT; ndahen me external id.',
    cnPickSite: 'Zgjidh site…',
    cnName: 'Emri',
    cnMqttPassword: 'Fjalëkalimi MQTT',
    cnPwKeep: 'bosh = pa ndryshim',
    cnPwOptional: 'opsional',
    cnActive: 'Aktiv',
    cnCancel: 'Anulo',
    cnSaving: 'Duke ruajtur…',
    cnSave: 'Ruaj',
    cnErrRequired: 'Site, emri dhe external id janë të detyrueshëm.',
    cnErrSave: 'Ruajtja dështoi.',
    'usNav_/dashboard': 'Dashboard',
    'usNav_/devices': 'Pajisjet',
    'usNav_/monitoring': 'Monitorimi',
    'usNav_/alarms': 'Alarmet',
    'usNav_/reports': 'Raportet',
    'usNav_/analysis': 'Analiza',
    'usNav_/production-planning': 'Planifikimi',
    'usNav_/control': 'Kontroll',
    'usNav_/users': 'Përdoruesit',
    'usNav_/companies': 'Kompanitë',
    'usNav_/connections': 'Lidhjet',
    'usNav_/platform-lab': 'Platforma Lab',
    'usNav_/me': 'Profili',
    usKicker: 'PROXNOVA / ADMINISTRIM',
    usNewRole: 'Rol i ri',
    usNew: 'Përdorues i ri',
    usHide: 'Fshih',
    usShow: 'Shfaq',
    usSearchPlaceholder: 'Kërko përdorues (emri, username, email)',
    usSearchAria: 'Kërko përdorues',
    usRoleFilter: 'Filtri i rolit',
    usAllRoles: 'Të gjitha rolet',
    usCompanyFilter: 'Filtri i kompanisë',
    usAllCompanies: 'Të gjitha kompanitë',
    usStatusFilter: 'Filtri i statusit',
    usAllStatuses: 'Të gjitha statuset',
    usActive: 'Aktiv',
    usInactive: 'Joaktiv',
    usNotFound: 'Nuk u gjet përdorues.',
    usMore: 'Më shumë',
    usView: 'Shiko',
    usEdit: 'Edito',
    usChangeRole: 'Ndrysho rolin',
    usDeactivate: 'Çaktivizo',
    usActivate: 'Aktivizo',
    usDelete: 'Fshi',
    usNotAllowed: 'Nuk lejohet',
    usChange: 'Ndrysho',
    usColName: 'Emri',
    usColRole: 'Roli',
    usColCompany: 'Kompania',
    usColStatus: 'Statusi',
    usColActions: 'Veprimet',
    usPagerAria: 'Faqet e përdoruesve',
    usPerPage: 'Përdorues për faqe',
    usOf: 'nga',
    usDetailsTitle: 'Detajet e përdoruesit',
    usClose: 'Mbyll',
    usEditTitle: 'Ndrysho Përdoruesin',
    usFieldFullName: 'Emri i plotë *',
    usFieldPassword: 'Fjalëkalimi *',
    usFieldConfirm: 'Konfirmo fjalëkalimin *',
    usFieldRole: 'Roli *',
    usFieldStatus: 'Statusi *',
    usHidePassword: 'Fshih fjalëkalimin',
    usShowPassword: 'Shfaq fjalëkalimin',
    usCompanyAccess: 'Kompani ku ka qasje',
    usCompanyInputPlaceholder: 'Shkruaj emrin e kompanisë...',
    usNoCompany: 'Nuk u gjet kompani.',
    usHint: 'Zgjidh kompanitë ku ky përdorues ka qasje në sistem. Fjalëkalimi përdoret për hyrje në sistem.',
    usNavigation: 'Navigimi',
    usCancel: 'Anulo',
    usSave: 'Ruaj',
    usErrNetworkShort: 'Lidhja me serverin dështoi.',
    usErrList: 'Gabim në ngarkimin e listës.',
    usErrPwLen: 'Fjalëkalimi duhet të ketë të paktën 8 karaktere.',
    usErrPwMatch: 'Fjalëkalimet nuk përputhen.',
    usWarnNoSite: 'Përdoruesi u ruajt, por këto kompani nuk kanë site në platformë (nuk u dha site_access): {names}',
    usErrNetwork: 'Lidhja me serverin dështoi. Kontrolloni që backend-i të jetë i ndezur.',
    usErrSave: 'Gabim gjatë ruajtjes.',
    usErrDelete: 'Gabim gjatë fshirjes.',
    usConfirmDeleteTitle: 'Konfirmo fshirjen',
    usConfirmDeleteMsg: 'A jeni të sigurt që dëshironi të fshini këtë përdorues?',
    usNo: 'Jo',
    usActivated: 'Përdoruesi u aktivizua.',
    usDeactivated: 'Përdoruesi u çaktivizua.',
    usErrStatus: 'Gabim gjatë ndryshimit të statusit.',
    cpUploadLogo: 'Ngarko logo',
    cpKicker: 'PROXNOVA / ADMINISTRIM',
    cpNew: 'Kompani e re',
    cpEditTitle: 'Ndrysho Kompaninë',
    cpSearchPlaceholder: 'Kërko kompani (emri, lokacioni)',
    cpSearchAria: 'Kërko kompani',
    cpStatusFilter: 'Filtri i statusit',
    cpAll: 'Të gjitha',
    cpActive: 'Aktiv',
    cpInactive: 'Joaktiv',
    cpNotFound: 'Nuk u gjet kompani.',
    cpMore: 'Më shumë',
    cpView: 'Shiko',
    cpEdit: 'Edito',
    cpChange: 'Ndrysho',
    cpDelete: 'Fshi',
    cpActivate: 'Aktivizo',
    cpDeactivate: 'Çaktivizo',
    cpColName: 'Emri',
    cpColLocation: 'Lokacioni',
    cpColPhone: 'Telefoni',
    cpColUnique: 'Nr. Unik',
    cpColStatus: 'Statusi',
    cpColActions: 'Veprimet',
    cpPagerAria: 'Faqet e kompanive',
    cpOf: 'nga',
    cpPerPage: 'Kompani për faqe',
    cpDetailsTitle: 'Detajet e kompanisë',
    cpClose: 'Mbyll',
    cpLogo: 'Logo',
    cpUploadLogoAria: 'Ngarko logon',
    cpLogoHold: 'Mbaj shtypur 3 sekonda për të ngarkuar logo (PNG)',
    cpFieldName: 'Emri i kompanisë *',
    cpFieldStatus: 'Statusi *',
    cpFieldLocation: 'Lokacioni *',
    cpFieldPhone: 'Telefoni *',
    cpFieldVat: 'Nr. TVSH',
    cpFieldLat: 'Gjerësia gjeografike (lat)',
    cpFieldLon: 'Gjatësia gjeografike (lon)',
    cpPlaceholderEg: 'p.sh.',
    cpCancel: 'Anulo',
    cpSave: 'Ruaj',
    cpUploadLogoTitle: 'Ngarko Logo',
    cpPickPng: 'Zgjidh një foto PNG (pa background) për logon e kompanisë.',
    cpBack: 'Kthehu',
    cpUploading: 'Duke ngarkuar...',
    cpPickPhoto: 'Zgjidh Foto',
    cpDeleteTitle: 'Fshij kompaninë?',
    cpDeleteMsg: 'A dëshironi ta largoni kompaninë {name}? Ky veprim nuk mund të kthehet.',
    cpErrPhotoSave: 'Gabim gjatë ruajtjes së fotos:',
    cpErrSavedPhotoFailed: 'Kompania u ruajt, por fotos së dashboard-it i dështoi ngarkimi:',
    cpErrNetwork: 'Lidhja me serverin dështoi. Kontrolloni që backend-i të jetë i ndezur.',
    cpErrDelete: 'Gabim gjatë fshirjes së kompanisë.',
    cpErrLogoSize: 'Logoja duhet të jetë më e vogël se 2MB.',
    cpActivated: 'Kompania u aktivizua.',
    cpDeactivated: 'Kompania u çaktivizua.',
    cpErrStatus: 'Gabim gjatë ndryshimit të statusit.',
    planKicker: 'PROXNOVA / OPERIM',
    planTitle: 'Planifikimi i Prodhimit',
    planPlant: 'Impianti',
    planDateHistory: 'Data (histori)',
    planDate: 'Data',
    planGenerate: 'Gjenero',
    planDownloadPdf: 'Shkarko PDF',
    planTabForecast: 'Parashikimi',
    planTabCompare: 'Krahasimi',
    planHint: 'Zgjidh kompaninë dhe prek Gjenero.',
    planYesterday: 'Dje',
    planTomorrow: 'Nesër',
    planHourlyHistory: 'Histori orë për orë',
    planForecastTomorrow: 'Parashikimi për nesër',
    planForecastTotal: 'Totali i parashikuar',
    planHours: 'Orët',
    planColHour: 'Ora',
    planColWind: 'Era m/s',
    planTotal: 'Total',
    planCompareTitle: 'Krahasimi i planifikimit',
    planForecastTitle: 'Parashikimi i prodhimit (P05)',
    planPeriod: 'Periudha',
    repGenerated: 'Gjeneruar',
    repProdTotal: 'Prodhimi total',
    repProdByCompany: 'Prodhimi sipas kompanive (MWh)',
    repProdMwh: 'Prodhimi (MWh)',
    repTotal: 'Total',
    repDocTitle: 'Raport',
    repDocTo: 'deri',
    repDocFleet: 'Raport i përbashkët',
    repDocEnergy: 'Raport i energjisë',
    repIndicator: 'Treguesi',
    repValue: 'Vlera',
    repKicker: 'PROXNOVA / ADMINISTRIM',
    repTitle: 'Raportet',
    repSubtitle: 'Raportet e energjisë për operimin, faturimin dhe menaxhimin.',
    repTabBuild: 'Gjenero',
    repTabBuildNote: 'Krijo raporte të reja',
    repTabHistory: 'Historiku',
    repTabHistoryNote: 'Shiko dhe menaxho',
    repTabFinanceFull: 'Konfigurimi financiar',
    repTabFinanceShort: 'Financat',
    repTabFinanceNote: 'Parametrat dhe llogaritjet',
    repTabAutoFull: 'Dërgimet automatike',
    repTabAutoShort: 'Dërgimet',
    repTabAutoNote: 'Planifiko dërgimet',
    repCompany: 'Kompania',
    repPlant: 'Impianti',
    repCategory: 'Kategoria',
    repType: 'Lloji i raportit',
    repAll: 'Të gjitha',
    repPeriod: 'Periudha',
    repPeriodToday: 'Sot',
    repPeriodYesterday: 'Dje',
    repPeriodMonth: 'Ky muaj',
    repPeriodLastMonth: 'Muaji i kaluar',
    repPeriodYear: 'Ky vit',
    repPeriodCustom: 'Interval i personalizuar',
    repCompare: 'Krahasimi',
    repCompareNone: 'Pa krahasim',
    repComparePrev: 'Periudha e mëparshme',
    repCompareYoy: 'Viti i kaluar',
    repFrom: 'Fillimi',
    repTo: 'Fundi',
    repTomorrowOnly: 'Ky raport tregon vetëm nesër.',
    repGenerating: 'Duke gjeneruar…',
    repGenerate: 'Gjenero raportin',
    repDownloadPdf: 'Shkarko PDF',
    repDownloadExcel: 'Shkarko Excel',
    repDelete: 'Fshi',
    repChooseParams: 'Zgjidh parametrat dhe gjenero raportin.',
    repDateFrom: 'Data fillimit',
    repDateTo: 'Data përfundimit',
    repFleetAll: 'Fleet · të gjitha',
    repSearch: 'Kërko',
    repColReport: 'Raporti',
    repColGenerated: 'Gjeneruar',
    repColActions: 'Veprimet',
    repCat_P: 'Prodhimi',
    repCat_F: 'Financat',
    repCat_A: 'Analiza',
    repCat_B: 'Bateritë',
    repCat_T: 'Raportet teknike',
    repCat_E: 'Raportet ekzekutive',
    repType_P01: 'Prodhimi ditor',
    repType_P02: 'Prodhimi mujor',
    repType_P03: 'Prodhimi vjetor',
    repType_P04: 'Bilanci energjetik',
    repType_P05: 'Parashikimi për nesër',
    repType_F01: 'Përmbledhja financiare mujore',
    repType_F02: 'Investimi dhe kthimi',
    repType_F03: 'Kredia dhe këstet',
    repType_F04: 'Cash Flow',
    repType_F05: 'NPV, IRR dhe skenarët',
    repType_A01: 'Krahasimi i periudhave',
    repType_A02: 'Performanca ndaj pritshmërive',
    repType_A03: 'Vetëkonsumi dhe pavarësia',
    repType_A04: 'Humbjet dhe anomalitë',
    repType_B01: 'Funksionimi i baterisë',
    repType_B02: 'Efikasiteti dhe shëndeti',
    repType_B03: 'Kontributi financiar',
    repType_T01: 'Disponueshmëria dhe ndërprerjet',
    repType_T02: 'Alarmet dhe ngjarjet',
    repType_T03: 'Pajisjet dhe mirëmbajtja',
    repType_E01: 'Përmbledhja menaxheriale',
    repType_E02: 'Portofoli i impianteve',
    almKicker: 'PROXNOVA / ADMINISTRIM',
    almTitle: 'Alarmet',
    almSecActiveFull: 'Alarmet aktive',
    almSecActiveShort: 'Aktive',
    almSecActiveNote: 'Monitorimi aktual i alarmeve',
    almSecHistFull: 'Historiku',
    almSecHistNote: 'Alarmet dhe ngjarjet e mëparshme',
    almSecNotifFull: 'Njoftimet',
    almSecNotifNote: 'Marrësit dhe rregullat e njoftimeve',
    almSecPiFull: 'Statusi nga Pi',
    almSecPiShort: 'Pi',
    almSecPiNote: 'Alarmet e inverterëve në kohë reale',
    almCriticalCount: '{n} kritike',
    almWarningCount: '{n} warning',
    almColAlarm: 'Alarmi',
    almColLevel: 'Niveli',
    almColActions: 'Veprimet',
    almStateOn: 'ON (Aktive)',
    almStateOff: 'OFF (Jo aktive)',
    almCompany: 'Kompania',
    almKindCritical: 'Alarmet kritike',
    almKindWarning: 'Paralajmërimet',
    almKindSchedule: 'Orari i njoftimeve',
    almSearch: 'Kërko',
    almSearchPlaceholder: 'Email ose rol',
    almRole: 'Roli',
    almUserActive: 'Aktiv',
    almUserInactive: 'Joaktiv',
    almNotifyHint: 'Alarmet kritike dhe paralajmërimet dërgohen me email kur ngrihet alarmi. Orari ruan marrësit për njoftimet e planifikuara.',
    almDetailsTitle: 'Detajet e alarmit',
    almDuration: 'Kohëzgjatja',
    almAckBy: 'Pranuar nga',
    almAckAt: 'Pranuar më',
    almResolvedAt: 'Zgjidhur më',
    almLevelInfo: 'INFO',
    devNew: 'Pajisje e re',
    devViewCards: 'V1 · Pajisjet',
    devViewTable: 'V2 · Tabela',
    devViewScheme: 'V3 · Skema',
    devViewAria: 'Versioni i pamjes',
    devEyebrow: 'PROXNOVA / MONITORIMI I PAJISJEVE',
    devAcProduction: 'PRODHIMI AC',
    devAcProductionSub: 'Shuma e inverterëve',
    devInvertersStat: 'INVERTERË',
    devInvertersStatSub: 'Pajisje që komunikojnë',
    devOnlineStatSub: 'Në inventar',
    devAlarmsStat: 'ALARMET',
    devAlarmsStatSub: 'Pa komunikim / alarm',
    devInventory: 'Inventari i pajisjeve',
    devFiltered: 'të filtruar',
    devInverters: 'inverterë',
    devTabAll: 'Të gjitha',
    devTabInverters: 'Inverterë',
    devKindAria: 'Lloji i pajisjes',
    devSchemeAria: 'Skema e lidhjeve',
    devSchemeTitle: 'Skema njëvijore',
    devAcGroups: 'grupe AC',
    devLegendEnergy: 'Energji AC/DC',
    devLegendComm: 'Komunikim',
    devBusbar: 'BUSBAR KRYESOR AC · INVERTERË PARALEL',
    devLoad: 'NGARKESA',
    devGrid: 'RRJETI',
    devMonitoring: 'Modbus TCP · monitorim',
    dashTodayProduction: 'Prodhimi sot',
    dashWeatherStationSolar: 'Stacioni i Motit (Solar)',
    dashDevicesAlarms: 'Pajisjet & alarmet',
    dashPlant3dTitle: 'Pamja 3D e impiantit',
    dashIrradianceGhi: 'Rrezatimi (GHI)',
    dashTempAmbient: 'Temp. ambient',
    dashTempModule: 'Temp. modul',
    dashWind: 'Era',
    dashHumidityPoa: 'Lagështia · POA',
    dashSolarOutput: 'Prodhimi solar',
    dashGridExport: 'Eksporti në rrjet',
    dashBuildingSupply: 'Furnizimi i objektit',
    logoutConfirm: 'A je i sigurt që do të dalësh nga llogaria?',
    more: 'Më shumë',
    navPanel: 'Paneli',
    navMonitor: 'Monitorimi',
    navCompany: 'Kompania',
    companyState: 'Gjendja e kompanive',
    allCompanies: 'Të gjitha kompanitë',
    alarmMessages: 'Mesazhet e fundit',
    noAlarms: 'Nuk ka alarme.',
    menu: 'Navigimi',
    home: 'Kryefaqja',
    devices: 'Pajisjet',
    alarms: 'Alarmet',
    reports: 'Raportet',
    monitoring: 'Monitoring',
    fleetMapAlarm: 'Alarm',
    fleetMapComm: 'Komunikimi',
    fleetMapFresh: 'Freskia',
    fleetMapProd: 'Prodhimi',
    fleetMapNone: 'asnjë',
    fleetMapUnknown: 'e panjohur',
    fleetMapOnline: 'online',
    fleetMapOffline: 'offline',
    fleetMapStale: 'e vjetër',
    fleetMapFreshWord: 'e freskët',
    fleetMapProducing: 'po prodhon',
    fleetMapIdle: 'e matur zero',
    fleetMapLegend: 'A alarm · C komunikim (X offline) · F freski (S e vjetër) · P prodhim. Teksti tregon gjendjen.',
    fleet_overview: 'Harta',
    pvFleet: 'Flota PV',
    digitalTwin: 'Binjaku Digjital',
    analysis: 'Analiza',
    analizat: 'Analizat',
    planning: 'Planifikimi',
    control: 'Kontroll',
    companies: 'Kompanitë',
    users: 'Përdoruesit',
    une: 'Profili',
    navOperations: 'Operimet',
    navEnergy: 'Energjia',
    navControl: 'Kontrolli',
    navAccount: 'Llogaria',
    navInternal: 'Mjete të brendshme',
    platformLab: 'Platforma Lab',
    shellClock: 'Ora',
    activeCompany: 'Kompania aktive',
    edgeLinkOk: 'Lidhja edge ok',
    edgeLinkDown: 'Lidhja edge jo',
    operationalScope: 'Fusha operative',
    allCompaniesFleet: 'Të gjitha kompanitë · Fusha e flotës',
    live: 'LIVE',
    crumbFleet: 'Flota',
    fleetControlRoom: 'Salla e kontrollit të flotës',
    fleetControlSub: 'Prodhimi live, alarmet dhe renditja e impianteve për fushën aktive.',
    designInventory: 'Inventar',
    designEnergyAnalysis: 'Analiza e energjisë',
    designAnalysisSub: 'Sjellja e energjisë në kohë, e ndarë nga operimi live.',
    designProfileSub: 'Të dhënat e llogarisë',
    designProfileDetails: 'Të dhënat e profilit',
    designProfileHint: 'Emri dhe emaili i llogarisë. Roli nuk ndryshohet këtu.',
    designProfileSaved: 'Profili u ruajt.',
    designProfileNeedName: 'Shkruaj emrin.',
    designProfileNeedEmail: 'Shkruaj një email të vlefshëm.',
    designMyAccount: 'Llogaria ime',
    designAccountMonitor: 'Monitorimi & raportet',
    designAccountSystem: 'Sistemi',
    designLogoutAccount: 'Dil nga llogaria',
    designHourlyBalance: 'Bilanci i energjisë · sot',
    designSelfVsExport: 'Vetë-konsumi kundrejt eksportit',
    designYearOnYear: 'Vit pas viti',
    designConsumptionBalance: 'Bilanci i konsumit',
    designConsumptionNote: 'Vetëm vlerat e matura shfaqen. Ndarjet që nuk maten mbeten bosh.',
    designPending: 'Në pritje',
    designTariffPending: 'Tarifë në pritje',
    designRevenuePending: 'Analiza e të ardhurave nuk është gati',
    designBenefitsPending: 'Analiza e përfitimeve nuk është gati',
    designNeedsMeter: 'Analiza e energjisë kërkon të dhëna nga matësi',
    designNeedsMeterHint: 'Kërkohet një matës energjie në të paktën një impiant',
    designPlanning: 'Planifikimi i prodhimit',
    designPlanningSub: 'Prodhimi faktik për orë kundrejt pritjes, dhe parashikimi i nesërm.',
    designActualVsExpected: 'Faktik kundrejt pritjes',
    designHourlyDetail: 'Detaji për orë',
    designActual: 'Faktik',
    designExpected: 'Pritur',
    designVariance: 'Ndryshimi',
    designIrradiance: 'Rrezatimi',
    designWeather: 'Moti',
    designForecastTag: 'Parashikim',
    designForecastProduction: 'Prodhimi i parashikuar',
    designPeakIrradiance: 'Rrezatimi maksimal',
    designExportCsv: 'Eksporto CSV',
    designControl: 'Kritik për sigurinë',
    designControlSub: 'Ndryshimet e pikës së punës shkruhen në pajisje dhe regjistrohen me përdoruesin tuaj.',
    designAlarmContext: 'Konteksti i alarmit',
    designAlarmDetails: 'Detajet e alarmit',
    designAlarmView: 'Shiko',
    alarm: 'Alarmi',
    time: 'Koha',
    level: 'Niveli',
    acknowledgedBy: 'Pranuar nga',
    resolve: 'Zgjidh',
    alarmLevelInfo: 'INFO',
    designAlarmPowerAround: 'Fuqia e pajisjes rreth ngjarjes',
    designAlarmTechnical: 'Detaji teknik',
    designOpenDevice: 'Hap pajisjen',
    designPlant: 'Impianti',
    designAlarmDuration: 'Kohëzgjatja',
    designAlarmState: 'Gjendja',
    designAlarmActive: 'AKTIV',
    designAlarmCleared: 'I PASTËR',
    designAlarmNotYet: 'ende jo',
    designAlarmOngoing: 'në vazhdim',
    designInvestigate: 'Heton',
    designCriticalAlarm: 'Alarm kritik',
    deviceType: 'Lloji i pajisjes',
    plant: 'Impianti',
    device: 'Pajisja',
    designWriteAccess: 'Qasje shkrimi',
    designStepTarget: 'Objektivi',
    designStepSetpoint: 'Pika',
    designStepReview: 'Rishikim',
    designStepAuthorise: 'Autorizim',
    designSelectTarget: '1 · Zgjidh pajisjen',
    designDefineSetpoint: '2 · Përcakto pikën e re',
    designImpactReview: '3 · Rishikimi i ndikimit',
    designAuthoriseCommand: '4 · Autorizo komandën',
    designControlMode: 'Mënyra e kontrollit',
    designCurrentOutput: 'Dalja aktuale',
    designRequested: 'E kërkuar',
    designReviewImpact: 'Rishiko ndikimin',
    designContinueAuth: 'Vazhdo te autorizimi',
    designTargetDevice: 'Pajisja e synuar',
    designNoControllable: 'Nuk ka inverterë në këtë data logger.',
    designFleetMap: 'Pamje gjeografike',
    fleetMapTitle: 'Harta',
    designPlantList: 'Lista e impianteve',
    administration: 'Administrimi',
    designAdmin: 'Platformë · Administrim',
    designAdminSub: 'Përdoruesit, kompanitë dhe lidhjet.',
    navMonitoring: 'MONITORING',
    systemSettings: 'Cilësimet e sistemit',
    connections: 'Lidhjet',
    about: 'Rreth Nesh',
    aboutApp: 'Rreth aplikacionit',
    connectionsHint: 'Statusi i lidhjeve dhe dokumentacioni i integrimit.',
    noGateways: 'Nuk ka porta të regjistruara.',
    configDrift: 'Konfigurimi i dëshiruar ndryshon nga i raportuari',
    inSync: 'I sinkronizuar',
    noDevicesOnGateway: 'Nuk ka pajisje në këtë portë.',
    reportedStatus: 'Statusi i raportuar',
    protocol: 'Protokolli',
    endpoint: 'Pika e lidhjes',
    enabled: 'Aktiv',
    unknown: 'I panjohur',
    loadFailed: 'Ngarkimi dështoi.',
    analysisNoLiveData: 'Nuk ka telemetri të matur për këtë kompani. Statistikat e rreme nuk shfaqen.',
    analysisPeriodUnmeasured: 'Totalet mujore dhe vjetore nuk llogariten duke shumëzuar energjinë e sotme.',
    analysisTariffPending: 'Të ardhurat dhe përfitimet kërkojnë tarifa të konfiguruara. Nuk ka të dhëna faturimi.',
    changePassword: 'Ndrysho fjalëkalimin',
    currentPassword: 'Fjalëkalimi aktual',
    newPassword: 'Fjalëkalim i ri',
    confirmNewPassword: 'Konfirmo fjalëkalimin',
    passwordChanged: 'Fjalëkalimi u ndryshua.',
    passwordChangeError: 'Nuk u ndryshua fjalëkalimi.',
    passwordMismatch: 'Fjalëkalimet e reja nuk përputhen.',
    languageLabel: 'Gjuha',
    themeLabel: 'Pamja',
    themeDark: 'E errët',
    themeLight: 'E ndritur',

    // Login
    loginTitle: 'Kyçu',
    loginSubtitle: 'Shkruaj kredencialet për të vazhduar',
    username: 'Përdoruesi',
    usernameOrEmailLabel: 'Përdoruesi ose email',
    passwordLabel: 'Fjalëkalimi',
    rememberCreds: 'Ruaj kredencialet',
    loginBtn: 'Kyçu',
    loggingIn: 'Duke u kyçur...',
    signInWithSso: 'Kyçu me SSO',
    orContinueWith: 'ose',
    developerLabToken: 'Token lab (zhvillues)',
    hideLabToken: 'Fshih token lab',
    labTokenLabel: 'Lab bearer token',
    continueWithLabToken: 'Vazhdo me lab token',
    errorNetwork: 'Lidhja me serverin dështoi.',
    errorLogin: 'Gabim gjatë kyçjes. Provoni përsëri.',
    toggleThemeLabel: 'Ndrysho light/dark',

    // Common
    loading: 'Duke ngarkuar...',
    accessDeniedPage: 'Nuk keni qasje në këtë faqe',
    cancel: 'Anulo',
    save: 'Ruaj',
    close: 'Mbyll',
    delete: 'Fshi',
    edit: 'Ndrysho',
    add: 'Shto',
    apply: 'Apliko',
    search: 'Kerko',
    back: 'Kthehu',
    confirm: 'A je i sigurt?',
    errorGeneric: 'Gabim',
    password: 'Fjalëkalim',
    confirmCheck: 'Konfirmoj',
    execute: 'Ekzekuto',
    sending: 'Duke dërguar...',
    noCompanies: 'Nuk ka kompani',
    selectCompany: 'Zgjidh kompaninë',
    selectCompanyFirst: 'Zgjidhni një kompani.',
    company: 'Kompani',
    dataLogger: 'Regjistrues i Të Dhënave',
    dataLoggers: 'Regjistruesit e Të Dhënave',
    inverter: 'Inverter',
    inverters: 'Inverterët',
    energyMeter: 'Njehsor Energjie',
    energyMeters: 'Njehsorët e Energjisë',
    status: 'Statusi',
    type: 'Lloji',
    actions: 'Veprime',
    online: 'Online',
    offline: 'Offline',
    commInterrupt: 'Ndërprerje komunikimi',
    catchUpInProgress: 'RIMBUSHJE NË VAZHDIM',
    catchUpInProgressHint: 'Gateway po dërgon të dhëna të ruajtura gjatë ndërprerjes. Grafikët historikë po plotësohen.',
    gapFilled: 'BOSHLLËKU U MBUSH',
    gapFilledHint: 'Rimbushja e radhës përfundoi. Të dhënat e vonuara u pranuan në historian.',
    deviceCommunicationLost: 'Komunikimi me pajisjen u humb',
    deviceCommunicationLostHint: 'Vlerat më poshtë janë leximet e fundit dhe nuk janë live. Asgjë nuk raportohet si zero.',
    deviceCommunicationLostCauseHint: 'Edge nuk po lexon Modbus. Shiko arsyen më sipër (timeout, exception, unit_id). Vlerat janë të fundit të njohura, jo live.',
    staleLastKnown: 'E VJETËR · E FUNDIT',
    live: 'LIVE',
    liveTelemetry: 'Telemetria live',
    deviceAlarms: 'Alarmet e pajisjes',
    noDeviceAlarms: 'Nuk ka alarme të regjistruara për këtë pajisje.',
    childDevices: 'Pajisjet e varura',
    communicationHealth: 'Shëndeti i komunikimit',
    context: 'Konteksti',
    readOnly: 'VETËM LEXIM',
    remoteControl: 'KONTROLL I LARGËT',
    parent: 'PRINDI',
    partial: 'Pjesërisht',
    normal: 'Normal',
    active: 'Aktive',
    inactive: 'Joaktive',
    total: 'Total',
    day: 'Dita',
    month: 'Muaji',
    year: 'Viti',
    week: 'Java',
    today: 'Sot',
    yesterday: 'Dje',
    tomorrow: 'Nesër',
    noData: 'Nuk ka të dhëna',

    emPowerFlowTitle: 'Rrjedhja e energjisë',
    emPowerFlowPpv: 'Ppv',
    emPowerFlowBattery: 'Fuqia e shkarkimit',
    emPowerFlowLoad: 'Fuqia e ngarkesës',
    emPowerFlowGridImport: 'Import',
    emPowerFlowExportTag: 'EKSPORT',
    emPowerFlowUnitKw: 'kW',
    emPowerFlowUnitMw: 'MW',

    // Control (ekzistojnë)
    controlDatalogger: 'Kontroll Datalogger',
    controlSubtitle: 'Zgjidhni kompaninë, data logger dhe kontrollin.',
    selectDataLogger: 'Zgjidh data logger',
    start: 'Start',
    stop: 'Stop',
    shutdown: 'Shutdown',
    enable: 'Enable',
    controlLabel: 'Kontrolli',
    limitProduction: 'Kufizo prodhimin',
    reactivePower: 'Reactive Power (kVar)',
    powerFactor: 'Power Factor (cosφ)',
    reactiveMode: 'Mënyra reaktive (Q / PF)',
    current: 'Aktual',
    applyQ: 'Apliko Q',
    applyPF: 'Apliko PF',
    applyMode: 'Apliko mënyrën',
    mode: 'Mode',
    disabled: 'Disabled',
    percent: 'Percent',
    kw: 'kW',
    qKvar: 'Q (kVar)',
    pfCos: 'PF (cosφ)',
    voltVar: 'Volt-Var',
    voltWatt: 'Volt-Watt',
    inverterList: 'Lista e inverterëve',
    selectAll: 'Select All',
    noInverters: 'Nuk ka inverterë.',
    selectDataLoggerFirst: 'Zgjidh data logger.',

    // Dashboard
    noCompaniesDash: 'No companies',
    noDataLoggers: 'No Data Loggers',
    addDataLoggerHint: 'Shto një data logger për këtë kompani',
    co2Today: 'CO2 Today',
    pvNow: 'PV Now',
    pvToday: 'PV Today',
    pvYesterday: 'PV Yesterday',
    todayProfit: "Today's Profit",
    updated: 'Përditësuar',
    justNow: 'just now',
    onGrid: 'ON GRID',
    offGrid: 'OFF GRID',
    flowing: 'në rrjedhje',
    production7days: 'Production 7 days (kWh)',
    energyFlow: 'Rrjedha e energjisë',
    pv: 'PV',
    load: 'Load',
    grid: 'Grid',
    production: 'Production',
    solar: 'Solar',
    pvPower: 'PV Power',
    capacity: 'Capacity',
    dayShort: 'Dita',
    monthShort: 'Muaji',
    yearShort: 'Viti',
    thisMonth: 'Këtë Muaj',
    thisYear: 'Këtë Vit',
    totalProduction: 'Total Production',
    urgentAlarms: 'Alarmet urgjente',
    recentAlarms: 'Alarmet e fundit',
    environmentalImpact: 'Impakti Mjedisor',
    co2TodayLabel: 'CO₂ Sot',
    treeEquivalent: 'Ekuivalent Pemësh',
    photoUploadSuccess: 'Foto u ngarkua me sukses!',
    photoUploadError: 'Gabim gjatë ngarkimit',
    uploadLogo: 'Ngarko Logo',
    goBack: 'Kthehu',
    productionByCompanies: 'Production by companies',
    hold3sForColor: 'Mbaj 3s mbi grafik për ndërruar ngjyrën',
    weatherStation: 'Stacioni i Motit (Solar)',
    radiation: 'Rrezatimi (GHI)',
    tempAmbient: 'Temp. ambient',
    tempModule: 'Temp. modul',
    wind: 'Era',
    humidityPoa: 'Lagështia · POA (rrafshi i paneleve)',

    // Devices
    allDevices: 'Të Gjitha Pajisjet',
    inverterBattery: 'Inverter dhe Bateri',
    ems: 'EMS (Njehsor Energjie)',
    addDevice: 'Shto Pajisje',
    deviceData: 'Të dhënat e pajisjes',
    noDevices: 'Nuk ka pajisje',
    updated1min: 'Updated 1 minute ago',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    detailedParams: 'Detailed Parameters',
    acInfo: 'AC Information',
    analysisGraph: 'Analysis Graph',
    dayLabel: 'Dita',
    weekLabel: 'Java',
    monthLabel: 'Muaji',
    yearLabel: 'Viti',
    lifetime: 'Gjithë Koha',
    totalLabel: 'Total',
    co2Label: 'CO₂',
    edit3s: '3s edit',
    editDevice: 'Ndrysho Pajisje',
    typeRequired: 'Lloji *',
    idRequired: 'ID *',
    select: 'Zgjidh...',
    brand: 'Brendi',
    selectBrand: 'Zgjidh brendin...',
    model: 'Modeli',
    serial: 'Seriali',
    ipAddress: 'IP Adresa',
    dataLoggerRequired: 'Data Logger *',
    powerKw: 'Fuqia (kW) *',
    port: 'Port',
    powerDisplayUnit: 'Shfaqja (MW ose kW)',
    unitId: 'Unit ID',
    photo: 'Foto',
    uploadPhoto: 'Ngarko Foto',
    uploadPhotoShort: '📷 Ngarko Foto',
    selectFile: 'Zgjidh skedar – Ngarko Foto',
    saving: 'Duke ruajtur...',
    idOnRaspberry: 'ID në Raspberry',
    power: 'Fuqia',
    noEdgeData: 'Nuk ka të dhëna edge ende.',
    confirmDeleteTitle: 'Konfirmo fshirjen',
    confirmDeleteDatalogger: 'A je i sigurt? Data Logger dhe të gjithë inverterët/energy meterët e lidhur do të fshihen.',
    confirmDeleteDevice: 'A je i sigurt qe do me fshi pajisjen?',
    deviceDeleted: 'Pajisja u fshi!',
    connectionFailed: 'Lidhja me serverin dështoi...',
    deleteError: 'Gabim gjatë fshirjes',
    selectCompanyRequired: 'Zgjidh një kompani!',
    selectDataLoggerRequired: 'Zgjidh Data Logger!',
    deviceUpdated: 'Pajisja u përditësua!',
    deviceAdded: 'Pajisja u shtua!',
    photoNotLoggedIn: 'Foto: nuk je i kyçur ose token i skaduar. Dil dhe kyçu përsëri.',
    deviceTypeRequired: 'Lloji i Pajisjes *',
    selectType: 'Zgjidh llojin...',
    selectInverter: 'Inverter',
    selectEnergyMeter: 'Energy Meter',
    optional: 'opsionale',
    serialPathRtu: 'Port serial në Raspberry (RS-485)',
    commHintDatalogger: 'Modbus TCP — IP dhe port të logger-it.',
    commHintEnergyMeter: 'Schneider/Siemens: zakonisht Modbus TCP (IP + port 502).',
    commHintChintEnergyMeter:
      'Energy Meter (DTSU666/DSSU666): lidhja është RS-485 në Raspberry; vendos portin serial (p.sh. /dev/ttyS1). Të dhënat sinkronizohen me Pi si pajisjet e tjera.',
    commHintKacoInverter: 'KACO: me RS-485 vendos serial_path; për TCP përdor IP e logger-it.',
    commHintModbusTcpHuaweiGrowatt: 'Modbus TCP përmes Data Logger.',
    commHintInverterOtherBrand: 'Modbus TCP — IP dhe port nga konfigurimi.',
    chintSerialPathRequired: 'Për Energy Meter (profili RS-485) duhet porti serial në Raspberry (p.sh. /dev/ttyS1).',

    // Alarms
    alarmSystem: 'Sistemi i Alarmeve',
    activeAlarms: 'Alarmet aktive',
    activeAlarmsList: 'Lista e alarmeve aktive në kohë reale',
    statusFromPi: 'Statusi nga Pi',
    alarmsFromInverters: 'Alarmet nga inverterët (Pi)',
    history: 'Historiku',
    alarmHistory: 'Historiku i alarmeve të mëparshme',
    notifications: 'Njoftimet',
    registerNotif: 'Regjistro email & SMS për njoftime',
    reportsSection: 'Raporte',
    alarmReports: 'Raporte të detajuara për alarme',
    activeOnly: 'Vetëm aktive',
    allDevicesFilter: 'Të gjitha pajisjet',
    noAlarms: 'Nuk ka alarme.',
    fromPi: 'Nga Pi',
    acknowledge: 'Pranoj',
    alarmRaised: 'Ngritur',
    alarmAcknowledged: 'Pranuar',
    alarmReturned: 'Kthyer në normale',
    alarmCleared: 'Mbyllur',
    alarmState_active: 'Aktiv',
    alarmState_acknowledged: 'Pranuar',
    alarmState_returned: 'Kthyer',
    alarmState_clear: 'Mbyllur',
    alarmLevelCritical: 'Kritik',
    alarmLevelWarning: 'Paralajmërim',
    alarmMsgGatewayOffline: 'Gateway offline: {id}',
    alarmMsgGatewayQuota: 'Kuota e ruajtjes së gateway: {id}',
    alarmMsgCommLoss: 'Humbje komunikimi: {id}',
    alarmMsgCommLossDetail: 'Humbje komunikimi: {id} — {detail}',
    alarmStatusFromPi: 'Statusi i alarmeve nga çdo inverter (të dhënat e fundit nga Pi).',
    noInvertersData: 'Nuk ka inverterë ose nuk ka të dhëna.',
    noAlarmList: 'Nuk ka listë alarmesh.',
    noHistoricalData: 'Nuk ka të dhëna historike.',
    updatedLabel: 'Përditësuar',
    acknowledged: 'Pranuar',
    email: 'Email',
    emailPlaceholder: 'email@shembull.com',
    companyOptional: 'Kompani (opsional)',
    all: 'Të gjitha',
    registerNotifications: 'Regjistro njoftime',
    myRegistrations: 'Regjistrimet e mia',
    noRegistrations: 'Nuk keni regjistrime.',
    alarmReportsHint: 'Raporte të detajuara për alarme dhe energji mund të gjenerohen nga faqja Raportet.',
    openReports: 'Hap Raportet',
    registerError: 'Gabim gjatë regjistrimit.',

    // Reports
    reportsTitle: 'Raportet',
    reportsSubtitle: 'Gjenero dhe eksporto raporte të energjisë',
    generateReport: 'Gjenero Raport',
    totalReports: 'Total Raporte',
    daily: 'Ditore',
    monthly: 'Mujore',
    yearly: 'Vjetore',
    noReportsGenerated: 'Nuk ka raporte të gjeneruara',
    generateFirstReport: 'Gjeneroni raportin e parë për të parë statistikat',
    productionLabel: 'Prodhimi',
    pvNowShort: 'PV tani',
    consumption: 'Konsumi',
    sold: 'E Shitur',
    revenue: 'Të Ardhura',
    pdf: 'PDF',
    generateNewReport: 'Gjenero Raport të Ri',
    reportType: 'Tipi i Raportit',
    startDate: 'Fillimi',
    endDate: 'Fundi',
    generating: 'Duke gjeneruar...',
    generate: 'Gjenero',
    reportGenerated: 'Raporti u gjenerua.',
    reportNoMeasuredData: 'Nuk ka të dhëna të matura për këtë periudhë.',
    reportLoadSeriesError: 'Nuk u ngarkuan të dhënat e matura të raportit.',
    reportAllAuthorized: 'Të gjithë të autorizuarit',
    reportSourceMeasured: 'Platformë · energji e matur',
    reportForecastUnavailable: 'Parashikimi nuk është i disponueshëm.',
    reportSourceForecast: 'Parashikim · planifikim',
    reportStudioTomorrow: 'Nesër',
    reportKpiDayProduction: 'Prodhimi i ditës',
    reportKpiPeakPower: 'Fuqia maksimale',
    reportKpiInverters: 'Inverterë',
    reportKpiCompleteness: 'Plotësia',
    reportKpiPeriodTotal: 'Totali i periudhës',
    reportKpiDailyAvg: 'Mesatarja ditore',
    reportKpiDays: 'Ditë',
    reportKpiYearTotal: 'Totali vjetor',
    reportKpiPrevYear: 'Viti i kaluar',
    reportKpiChange: 'Ndryshimi',
    reportKpiForecastTotal: 'Totali i parashikuar',
    reportKpiHours: 'Orët',
    reportKpiPlant: 'Impianti',
    reportKpiStatus: 'Statusi',
    reportColInverter: 'Inverteri',
    reportColProduction: 'Prodhimi',
    reportColShare: 'Pesha',
    reportColDay: 'Dita',
    reportColMonth: 'Muaji',
    reportColThisYear: 'Ky vit',
    reportColLastYear: 'Viti i kaluar',
    reportColChange: 'Ndryshimi',
    reportColFlow: 'Fluksi',
    reportColEnergy: 'Energjia',
    reportColHour: 'Ora',
    reportColEmKwh: 'EM kWh',
    reportColAmb: 'Amb °C',
    reportColMod: 'Mod °C',
    reportColWind: 'Era m/s',
    reportFlowPv: 'Prodhimi PV',
    reportFlowSelf: 'Vetëkonsumi',
    reportFlowExport: 'Eksporti',
    reportFlowImport: 'Importi',
    reportFlowCharge: 'Ngarkim baterie',
    reportFlowDischarge: 'Shkarkim baterie',
    reportQueued: 'Raporti u radhit. Shifrat shfaqen vetëm pasi CSV të jetë gati.',
    reportNotReady: 'Raporti nuk është gati për shkarkim.',
    excelColCompany: 'Kompania',
    excelColTag: 'Matja',
    excelColDirection: 'Drejtimi',
    excelColUnit: 'Njësia',
    excelColMeasured: 'E matur (kWh)',
    excelColEstimated: 'E vlerësuar (kWh)',
    excelColAccepted: 'Rreshta të pranuara',
    excelColEstimatedRows: 'Rreshta të vlerësuara',
    excelDirProduction: 'Prodhimi',
    excelDirExport: 'Eksporti',
    excelDirImport: 'Importi',
    excelDirConsumption: 'Konsumi',
    excelDirOther: 'Tjetër',
    permGroupCommands: 'Komandat',
    permGroupCompanies: 'Kompanitë',
    permGroupConfig: 'Konfigurimi',
    permGroupDevices: 'Pajisjet',
    permGroupEnergy: 'Energjia',
    permGroupGateways: 'Gateway',
    permGroupHistory: 'Historia',
    permGroupReports: 'Raportet',
    permGroupSites: 'Site-t',
    permGroupTags: 'Etiketat',
    permGroupTenants: 'Qiramarrësit',
    permGroupUsers: 'Përdoruesit',
    'perm.commands:request': 'Kërko komanda në distancë',
    'perm.commands:approve': 'Mirato komanda në distancë',
    'perm.companies:read': 'Shiko dhe lexo kompanitë',
    'perm.companies:write': 'Krijo, përditëso dhe fshi kompanitë',
    'perm.config:draft': 'Krijo rishikime draft të konfigurimit',
    'perm.config:publish': 'Publiko konfigurimin e dëshiruar te një gateway',
    'perm.config:read': 'Lexo rishikimet e konfigurimit dhe gjendjen e sinkronizimit',
    'perm.config:report': 'Regjistro gjendjen e konfigurimit të raportuar nga gateway',
    'perm.devices:read': 'Lexo pajisjet',
    'perm.devices:write': 'Shkruaj pajisjet',
    'perm.energy:read': 'Lexo përkufizimet, deltat dhe problemet e numëruesve të energjisë',
    'perm.energy:write': 'Krijo, përditëso dhe fshi përkufizimet e numëruesve të energjisë',
    'perm.gateways:read': 'Lexo gateway-t',
    'perm.gateways:write': 'Shkruaj gateway-t',
    'perm.history:read': 'Lexo matjet historike të telemetrisë',
    'perm.reports:request': 'Kërko raporte asinkrone',
    'perm.sites:read': 'Lexo site-t',
    'perm.sites:write': 'Shkruaj site-t',
    'perm.tags:read': 'Lexo etiketat',
    'perm.tags:write': 'Shkruaj etiketat',
    'perm.tenants:read': 'Shiko dhe lexo qiramarrësit',
    'perm.tenants:write': 'Krijo dhe përditëso qiramarrësit',
    'perm.users:read': 'Shiko përdoruesit dhe rolet e qiramarrësit',
    'perm.users:write': 'Krijo, përditëso dhe çaktivizo përdoruesit e qiramarrësit',
    reportNoMeasured: 'Nuk ka matje të pranuara në këtë periudhë. Zero nuk është sajuar.',
    reportDownloadCsv: 'CSV',
    reportStatusQueued: 'Në radhë',
    reportStatusRunning: 'Duke u llogaritur',
    reportStatusCompleted: 'Gati',
    reportStatusFailed: 'Dështoi',
    reportStatusRejected: 'Refuzuar',
    reportStatusExpired: 'Skaduar',
    reportError: 'Gabim gjatë gjenerimit të raportit.',
    reportAllCompanies: 'Të gjitha kompanitë (raport i përbashkët)',
    reportAllCompaniesMyAccess: 'Të gjitha kompanitë ku kam qasje',
    reportFleetGenerated: 'Raporti i përbashkët për të gjitha kompanitë u gjenerua.',
    reportFleetCompanyLabel: 'Të gjitha kompanitë',
    reportFleetPdfSectionsHint: 'PDF me seksione për çdo kompani',
    reportFleetByCompanyMwh: 'Prodhimi sipas kompanive (MWh)',
    reportFleetTableCompany: 'Kompania',
    reportFleetTableMwh: 'Prodhimi (MWh)',
    reportFleetTableTotal: 'Total',
    reportGridExportKwhLabel: 'Eksport',
    reportGridImportKwhLabel: 'Import',
    reportFleetTableExportKwh: 'Eksport',
    reportFleetTableImportKwh: 'Import',
    pvFleetAllCompanies: 'Të gjitha',
    pvFleetEnergyShort: 'Të gjitha kompanit',
    pvFleetBackToDashboard: 'Kthehu te ballina',
    reportsBulkAllOk: 'U gjeneruan {{n}} raporte (një për çdo kompani).',
    reportsBulkNone: 'Nuk u gjenerua asnjë raport.',
    reportsBulkPartialOk: 'U gjeneruan {{ok}} nga {{total}} raporte; disa kompani dështuan.',
    deleteReport: 'Fshi',
    deleteReportDialogTitle: 'Fshirja e raportit',
    confirmDeleteReport: 'Jeni të sigurt që doni të fshini këtë raport?',
    reportDeleted: 'Raporti u fshi.',
    reportDeleteError: 'Gabim gjatë fshirjes së raportit.',
    reportsFilterListPeriod: 'Filtro sipas periudhës së raportit',
    reportsSearchPlaceholder: 'Kërko (tipi, kompani, data…)',
    reportsClearFilters: 'Pastro filtrat',
    reportsNoFilterResults: 'Nuk ka raporte që përputhen me filtrat.',
    dailyReport: 'Ditor',
    weeklyReport: 'Javor',
    monthlyReport: 'Mujor',
    yearlyReport: 'Vjetor',
    companyLabel: 'Kompania',
    energyReport: 'Raport i Energjisë',
    period: 'Periudha',
    metric: 'Metrika',
    value: 'Vlera',
    totalProductionLabel: 'Prodhimi Total',
    totalConsumption: 'Konsumi Total',
    energySold: 'Energjia e Shitur',
    totalRevenue: 'Të Ardhurat Totale',
    alarmActive: 'Aktiv',
    alarmInactive: 'Jo aktiv',
    // Monitoring
    monitoringTitle: 'Monitorimi – Të dhënat e fundit',
    checkingConnection: 'Duke kontrolluar lidhjen...',
    monitoringNotConnected: 'Qendra rajonale nuk është e lidhur',
    monitoringNotConnectedHint: 'Lidhja me qendrën rajonale të të dhënave në kohë reale është e pamundur për momentin.',
    sshTunnelHint: 'Në VPS ekzekutoni tunelin:',
    monitoringRegionalLinkBanner:
      'Lidhja e shpejtë me qendrën rajonale nuk përgjigjet. Harta dhe listat e mëposhtme ngarkohen nga serveri kryesor; vlerat PV/sot mund të përditësohen me vonesë.',
    inverterLastRead: 'Inverter (leximi i fundit)',
    dataloggerLastRead: 'Data logger (leximi i fundit)',
    energyMeterLastRead: 'Njehsor energjie (leximi i fundit)',
    alarmsLast10: 'Alarmet (10 të fundit)',
    deviceStatus: 'Statusi pajisjes',
    dailyEnergy: 'Energji ditore (kWh)',
    totalEnergy: 'Energji totale',

    // Analysis
    energyManagement: 'Menaxhimi i Energjisë',
    energy: 'Energjia',
    energyAnalysis: 'Analiza e Energjisë',
    consumptionAnalysis: 'Analiza e Konsumit',
    revenueAnalysis: 'Analiza e të Ardhurave',
    benefits: 'Përfitimet',
    selectDates: 'Zgjidh Datat',
    energyBalance: 'Bilanci i Energjisë',
    selfConsumption: 'Vetë-Konsumi',
    exportLabel: 'Eksporti',
    selfSufficiency: 'Vetë-Mjaftueshmëria',
    buyFromGrid: 'Blerja nga Rrjeti',
    supply: 'Furnizimi (kW)',
    usage: 'Përdorimi',
    loads: 'Ngarkesa',
    network: 'Rrjeti',
    solarGen: 'Diellore',
    generation: 'Gjenerimi',
    imported: 'Importuar',
    pvProduced: 'PV Prodhuar',
    discharged: 'Shkarkuar',
    exported: 'Eksportuar',
    consumed: 'Konsumuar',
    charged: 'Ngarkuar',
    selectPeriod: 'Zgjidh Periudhën',
    fromDate: 'Nga Data',
    toDate: 'Deri në Datën',

    // ProductionPlanning
    productionPlanning: 'Planifikimi i Prodhimit',
    selectDate: 'Data (kalendar për historik)',
    selectCompanyForData: 'Zgjidhni një kompani për të parë të dhënat.',
    selectDateAndSearch: 'Zgjidhni një datë (ose Dje) dhe klikoni Kerko.',
    clickSearchHint: 'Klikoni Kerko për të kërkuar të dhënat për {date}.',
    loadingData: 'Duke ngarkuar të dhënat...',
    noEnergyMeters: 'Nuk ka energy meterë për këtë kompani.',
    weatherHint: 'Të dhënat e motit (GHI, temp, erë) do të shfaqen kur instaloni weather station.',
    hour: 'Ora',
    emProduction: 'EM Prodhimi (kWh)',
    dataloggerKwh: 'Datalogger (kWh)',
    difference: 'Ndryshimi (EM−DL)',
    radiationGhi: 'Rrezatimi (GHI) W/m²',
    tempAmbientC: 'Temp. ambient °C',
    tempModuleC: 'Temp. modul °C',
    windSpeed: 'Era (m/s)',
    weatherOnlyHint: 'Vetëm moti (Open-Meteo). Prodhimi do të shfaqet kur instaloni energy meter.',
    emDlHint: 'EM = Energy Meter (pi_energy_meter_readings). DL = Datalogger (pi_datalogger_readings, energy_total_mwh). Ndryshimi = EM − DL (pozitiv = meter më shumë se datalogger, negativ = datalogger më shumë).',
    data: 'Data',
    productionAndWeatherHourly: 'Prodhimi dhe moti për orë (05:00–20:00)',
    planningForecastSubtitle: 'Parashikim (similar-days); prodhimi = modeli, moti = forecast + stacion',
    planningLabEstimateTitle: 'Vlerësim laboratori — jo parashikim operacional',
    planningLabEstimateBody: 'Kjo është tavani i rrezatimit në qiell të kthjellët (Haurwitz). Retë nuk llogariten. Prodhimi nuk vlerësohet pa kapacitet të miratuar. Në prodhim ky ekran është i fikur.',
    planningCoordinatesMissing: 'Mungojnë koordinatat e impiantit. Pa to nuk llogaritet as tavani i qiellit të kthjellët.',
    planningNoSites: 'Kompania nuk ka site aktiv.',
    planningTimezoneMissing: 'Site-i nuk ka zonë kohore.',
    planningMixedTimezones: 'Site-t e kompanisë kanë zona kohore të ndryshme. Kërkojeni veç e veç.',
    planningForecastDisabled: 'Vlerësimi laboratorik është i fikur.',
    planningGenerated: 'Planifikimi u gjenerua.',
    planningSiteForbidden: 'Nuk keni qasje te site-t e kësaj kompanie.',
    reportsDisabledHint: 'Raportet janë të fikura në server (PLATFORM_API_REPORTS_ENABLED).',
    reportForbidden: 'Nuk lejohet gjenerimi i raportit (403).',
    reportCategoryUnavailable: 'Kjo kategori nuk gjenerohet ende — përdor Prodhimi.',
    clearSkyCeiling: 'Tavan qielli i kthjellët (W/m²)',
    weatherLabSeed: 'Moti laboratorik (jo stacion)',
    weatherStation: 'Stacioni i motit',
    planningEmptyHint:
      'Për historik: zgjidhni datën (ose Dje) dhe klikoni Kerko. Për tavanin laboratorik: klikoni Nesër. Data është dita civile e ardhshme në zonën e site-it, jo +24 orë.',
    planningForecastExportTitle: 'Planifikim — Parashikim',
    planningHistoryExportTitle: 'Planifikim — Eksport',
    forecastSimilarDays: 'Ditë të ngjashme',
    forecastDailyTotal: 'Total ditor (parashikim)',

    // Companies
    companiesTitle: 'Kompanit',
    companiesSubtitle: 'Menaxho kompanitë dhe të dhënat',
    setDashboardPhoto: 'Vendos foton e dashboard-it për të gjitha',
    setting: 'Duke vendosur...',
    addCompany: '+ Shto Kompani',
    totalCompanies: 'Total Kompani',
    noCompaniesRegistered: 'Nuk ka kompani të regjistruara',
    addFirstCompany: 'Shtoni kompaninë e parë për të filluar',
    logo: 'Logo',
    companyName: 'Emri i kompanisë',
    address: 'Adresa',
    phone: 'Telefoni',
    website: 'Website',
    uniqueNr: 'Nr. Unik',
    vatNr: 'Nr. TVSH',
    hold3sForLogo: 'Mbaj shtypur 3 sekonda për të ngarkuar logo (PNG)',
    editCompany: 'Ndrysho Kompaninë',
    addNewCompany: 'Shto Kompani të Re',
    dashboardPhoto: 'Foto e dashboard-it (opsionale)',
    dashboardPhotoHint: 'Çdo kompani e ka foton e vet në faqen e parë (dashboard)...',
    selectDashboardPhoto: 'Zgjidh foton e dashboard-it',
    companyNameRequired: 'Emri i kompanisë *',
    selectPhoto: 'Zgjidh një foto PNG...',
    selectImage: 'Zgjidh Foto',
    pngOnly: 'Lejohet vetëm skedar PNG (.png).',
    confirmDeleteCompany: 'A jeni të sigurt që dëshironi të fshini këtë kompani?',
    confirmSeedDashboardPhotos: 'Vendos foton e dashboard-it për të gjitha kompanitë? Më vonë mund ta ndryshoni nga modali "Ndrysho Kompaninë".',
    logoUploaded: 'Logo u ngarkua me sukses!',
    uploadError: 'Gabim gjatë ngarkimit',
    imagesOnly: 'Lejohen vetëm imazhe: PNG, JPG, JPEG, WEBP.',
    dashboardPhotoUploaded: 'Fotoja e dashboard-it u ngarkua me sukses!',
    companySaveError: 'Gabim gjatë ruajtjes së kompanisë.',
    deleteCompanyError: 'Gabim gjatë fshirjes së kompanisë.',

    // Users
    usersTitle: 'Përdoruesit',
    addUser: '+ Shto Përdorues',
    ensureBackendRunning: 'Sigurohuni që backend-i (FastAPI) është i ndezur në portin 8000.',
    tryAgain: 'Provë përsëri',
    closeMessage: 'Mbylle',
    closeMessageAria: 'Mbylle mesazhin',
    name: 'Emri',
    usernameLabel: 'Username',
    emailLabel: 'Email',
    companyLabelUsers: 'Kompania',
    editUser: 'Ndrysho Përdoruesin',
    addNewUser: 'Shto Përdorues të Ri',
    fullName: 'Emër Mbiemër',
    fullNameAlt: 'Emri Mbiemri',
    passwordOptional: 'Fjalëkalimi (opsional)',
    role: 'Role',
    navigation: 'Navigimi',
    selectCompanyUsers: 'Zgjidh Kompanin',
    allowedNavigation: 'Navigimi i Lejuar',
    none: 'Asnjë',
    companiesCount: 'kompani',
    pages: 'faqe',
    allOption: 'Të gjitha',
    confirmDeleteUser: 'A jeni të sigurt që dëshironi të fshini këtë përdorues?',
    saveError: 'Gabim gjatë ruajtjes.',
    deleteUserError: 'Gabim gjatë fshirjes.',

    // DataLoggerDetail
    activePower: 'Active Power',
    reactivePower: 'Reactive Power',
    powerFactor: 'Power Factor (PF)',
    energyToday: 'Energy (Today)',
    totalEnergyYield: 'Total Energy Yield',
    fault: 'Fault',
    standby: 'Standby',
    totalProductionLabel: 'Prodhimi Total',
    deviceInfo: 'Device Information',
    modelLabel: 'Model',
    ipLabel: 'IP',
    portLabel: 'Port',
    totalInverter: 'Total Inverter',
    details: 'Details',
    realTime: 'Real Time',

    // InverterDetail
    inverterNotFound: 'Inverteri nuk u gjet',
    inverterDetails: 'Detajet e Inverterit',
    statusAndEnergy: 'Statusi & Energjia',
    power: 'Fuqia',
    pvVoltage: 'Tensioni PV',
    pvCurrent: 'Rryma PV',
    gridAndPhase: 'Rrjeti & Faza',
    system: 'Sistemi',
    pvPower: 'Fuqia PV',
    todayPvYield: 'Prodhimi sot PV',
    totalPvYield: 'Prodhimi total PV',
    monthlyPvYield: 'Prodhimi mujor PV',
    energyAnalysis: 'Analiza e Energjisë',
    details: 'Detajet',
    realTime: 'Kohë Reale',
    alarms: 'Alarmet',
    realtimeCurve: 'Lakorja në kohë reale',
    deviceStatus: 'Statusi i pajisjes',
    energyYieldCurrentDay: 'Energjia e ditës aktuale',
    totalEnergyYield: 'Energjia totale',
    reducedCo2Emission: 'CO₂ i reduktuar',
    dcPower: 'Fuqia DC',
    activePower: 'Fuqia aktive',
    reactivePower: 'Fuqia reaktive',
    powerFactor: 'Faktori i fuqisë',
    gridAbBcCaVoltage: 'Tensioni rrjeti AB/BC/CA',
    gridAbcPhaseCurrent: 'Rryma fazore A/B/C',
    todayPeakActivePower: 'Fuqia kulmore sot',
    gridFrequency: 'Frekuenca e rrjetit',
    locking: 'Kyçja',
    cabinetTemperature: 'Temp. kabineti',
    startupTime: 'Koha e fillimit',
    shutdownTime: 'Koha e ndaljes',
    collectDspData: 'Mbledhja e të dhënave DSP',
    activePowerAdjustment: 'Rregullimi i fuqisë aktive',
    reactivePowerAdjustment: 'Rregullimi i fuqisë reaktive',
    pv18Voltage: 'PV1-8 tension',
    pv916Voltage: 'PV9-16 tension',
    pv1724Voltage: 'PV17-24 tension',
    pv2528Voltage: 'PV25-28 tension',
    pv18Current: 'PV1-8 rrymë',
    pv916Current: 'PV9-16 rrymë',
    pv1724Current: 'PV17-24 rrymë',
    pv2528Current: 'PV25-28 rrymë',
    allDevices: 'Të Gjitha Pajisjet',
    inverterTab: 'Inverter',
    emsTab: 'EMS',
    noAlarmsInverter: 'Nuk ka alarme.',

    // EnergyMeterDetail
    energyMeterNotFound: 'Njehsor energjie nuk u gjet',
    alarmHistoryLabel: 'Historiku i Alarmave',
    activeAlarmsLabel: 'Alarmet Aktive',
    noActiveAlarms: 'Nuk ka alarme aktive.',
    noAlarms: 'Nuk ka alarme.',
    activePowerReal: 'Fuqia Aktive (Fuqia Reale)',
    todayEnergy: 'Energjia Sot',
    monthlyEnergy: 'Energjia Mujore (1–31)',
    totalEnergyLabel: 'Energjia Totale',
    emKpiActivePower: 'Fuqia aktive',
    emKpiToday: 'Sot',
    emKpiMonth: 'Muaji',
    emKpiPowerFactor: 'Faktori i fuqisë',
    emEnergyDirection: 'Drejtimi i energjisë',
    emFourQuadrant: '4 kuadrante',
    emSiteEnergy: 'Energjia e sitit',
    emGridImport: 'Import nga rrjeti',
    emGridExport: 'Eksport në rrjet',
    emPhases: 'Fazat',
    emHistory: 'Historiku',
    emImportExportCounters: 'Numëruesit import / eksport',
    emGridImportTotal: 'Import total nga rrjeti',
    emGridExportTotal: 'Eksport total në rrjet',
    emImportToday: 'Importi sot',
    emReactiveImport: 'Import reaktiv',
    emReactiveExport: 'Eksport reaktiv',
    emUpdatedPrefix: 'përditësuar',
    emActiveCount: 'aktive',
    emExportActivePower: 'Eksport / fuqi aktive',
    emMonitoring: 'MONITORIMI',
    emTabDetails: 'Detajet',
    emTabRealtime: 'Kohë reale',
    emTabAlarms: 'Alarmet',
    emTabInOut: 'Hy–Dil',
    emPeriodDay: 'Ditë',
    emPeriodMonth: 'Muaj',
    emPeriodYear: 'Vit',
    emPeriodTotal: 'Total',
    emDateLabel: 'Data',
    chintCardProduction: 'Prodhimi',
    chintCardLoad: 'Ngarkesa',
    chintCardImport: 'Import',
    chintCardExport: 'Eksport',
    meterDetails: 'Detajet e Njehsorit',
    energyAnalysisLabel: 'Analiza e Energjisë',
    emChartTimeLabel: 'Koha',
    emSeriesSystemProduction: 'Prodhim sistemi',
    emSeriesSolarProduction: 'Prodhim solar',
    emSeriesLoadConsumption: 'Konsum ngarkese',
    emSeriesSelfConsumption: 'Vetë-konsum',
    emSeriesExportToGrid: 'Eksport në rrjet',
    emSeriesImportFromGrid: 'Import nga rrjeti',
    emSeriesCharged: 'E ngarkuar (bateri)',
    emSeriesDischarged: 'E shkarkuar (bateri)',
    emSystemProductionTotal: 'Prodhimi i sistemit:',
    emLoadConsumptionTotal: 'Konsumi i ngarkesës:',
    inOut: 'Hy-Dil',
    photoUpload: 'Ngarko Foto',
    photoUploadFor: 'Ngarko Foto për',
    selectPhoto: 'Zgjidh Foto',
    exportLabel: 'Eksport',
    totalLabel: 'Total',
    emSectionPower: 'Fuqia',
    emSectionEnergy: 'Energjia',
    emSectionVoltage: 'Tensioni',
    emSectionCurrent: 'Rryma',
    emSectionFrequency: 'Frekuenca',
    emSectionDemand: 'Kërkesa (Peak)',
    emSectionAdvanced: 'Avancuar',
    digitalIO: 'I/O Digjitale',
    inputs: 'Inpute',
    outputs: 'Outpute (mban >5s për shkrim)',
    figureScheme: 'Figurë / Skemë',
    verifyPayload: 'Verifiko payload (raw nga API)',
    writeDO: 'Shkruaj DO1/DO2',
    confirmStopStart: 'A je i sigurt? Don me ndal apo me dhez?',
    send: 'Dërgo',

    // DetailedParameters / Inverter Param Sections
    detailedParameters: 'Parametrat e Detajuar',
    pvInfo: 'Informacioni PV',
    voltage: 'Tensioni (V)',
    currentLabel: 'Rryma (A)',
    powerLabel: 'Fuqia (kW)',
    acInfo: 'Informacioni AC',
    frequency: 'Frekuenca (Hz)',
    gridInfo: 'Informacioni i Rrjetit',
    gridStatus: 'Statusi i Rrjetit',
    loadInfo: 'Informacioni i Ngarkesës',
    gridPower: 'Fuqia e Rrjetit',
    acVoltage: 'Tensioni AC',
    acCurrent: 'Rryma AC',
    acFrequency: 'Frekuenca AC',
    loadPower: 'Fuqia e Ngarkesës',
    loadCurrent: 'Rryma e Ngarkesës',
    pv1Voltage: 'Tensioni PV1',
    pv1Current: 'Rryma PV1',
    pv2Voltage: 'Tensioni PV2',
    pv2Current: 'Rryma PV2',
    plantCondition: 'Gjendja e impiantit',
    dlInputPowerDc: 'Fuqia hyrëse / DC',
    dlGridPhaseCurrents: 'Rrymat fazore të rrjetit',
    dlLockStatus: 'Statusi i kyçjes',
    dlAcOutput: 'Dalja AC',
    dlEfficiency: 'Efikasiteti',
    dlPhaseL1: 'L1',
    dlPhaseL2: 'L2',
    dlPhaseL3: 'L3',
    dlLink: 'Lidhja',
    dlProtocol: 'Protokolli',
    dlNoComm: 'Pajisje pa komunikim',
    dlAvailability: 'Disponueshmëria',
    dlLoad: 'Ngarkimi',
    dlReactiveAdjustmentLimits: 'Kufijtë e Rregullimit Reaktiv',
    dlActiveAdjustmentLimits: 'Kufijtë e Rregullimit Aktiv',
    dlPvReactiveLimits: 'Kufijtë Reaktivë PV',
    dlEssReactiveLimits: 'Kufijtë Reaktivë ESS',
    dlPvActiveLimit: 'Kufiri Aktiv PV',
    dlEssPeaks: 'Kulmet ESS',
    dlApiOverrideStatuses: 'Statuset e Anashkalimit të API',
    dlRemoteScheduling: 'Planifikimi nga largësia',
    dlKpi: 'KPI',
    dlActivePower: 'Fuqia aktive',
    dlDcPower: 'Fuqia DC',
    dlInputPowerKw: 'Fuqia hyrëse (kW)',
    dlDcCurrentA: 'Rryma DC (A)',
    dlGridAPhaseCurrent: 'Rryma fazore A (A)',
    dlGridBPhaseCurrent: 'Rryma fazore B (A)',
    dlGridCPhaseCurrent: 'Rryma fazore C (A)',
    dlLockStatusLabel: 'Statusi i kyçjes',
    dlReducedCo2Kg: 'CO₂ i reduktuar (kg)',
    dlMaxReactiveAdj: 'Vlera maks. për rregullim reaktiv (kVar)',
    dlMinReactiveAdj: 'Vlera min. për rregullim reaktiv (kVar)',
    dlMaxActiveAdj: 'Vlera maks. për rregullim aktiv (kW)',
    dlMinActiveAdj: 'Vlera min. për rregullim aktiv (kW)',
    dlPvReactiveMax: 'Vlera më e lartë reaktive PV (kVar)',
    dlPvReactiveMin: 'Vlera më e ulët reaktive PV (kVar)',
    dlEssReactiveMax: 'Vlera më e lartë reaktive ESS (kVar)',
    dlEssReactiveMin: 'Vlera më e ulët reaktive ESS (kVar)',
    dlPvActiveMax: 'Vlera më e lartë aktive PV (kW)',
    dlEssDischargeMax: 'Fuqia maksimale shkarkimi ESS (kW)',
    dlEssChargeMax: 'Fuqia maksimale ngarkimi ESS (kW)',
    dlApiActiveOverride: 'API aktive me përparësi të ulët të anashkaluara',
    dlApiReactiveOverride: 'API reaktive me përparësi të ulët të anashkaluara',
    dlRemoteSchedP: 'Planifikim komunikimi nga largësia (P)',
    dlRemoteSchedQ: 'Planifikim komunikimi nga largësia (Q)',
    dailyFeedIn: 'Daily feed-in energy',
    totalFeedIn: 'Total feed-in energy',
    dailyPurchased: 'Daily purchased energy',
    totalPurchased: 'Total purchased energy',
    feedInPower: 'Feed-in power',
    purchasedPower: 'Purchased power',
    loadInfo: 'Load Information',
    dailyLoadConsumption: 'Daily Load Consumption',
    totalLoadConsumption: 'Total Load Consumption',
    totalLoadPower: 'Total Load Power',
    gridLoadPower: 'Grid Load Power',
    epsLoadPower: 'EPS Load Power',

    // SCADA-L02 operator strings (dashboard / control / fleet / planning)
    noDataToday: 'Nuk ka të dhëna për sot',
    noDataLoggersForCompany: 'Nuk ka Data Logger për këtë kompani',
    noEnergyMetersForCompany: 'Nuk ka Energy Meter për këtë kompani',
    noInvertersForCompany: 'Nuk ka Inverter për këtë kompani',
    treesUnit: 'pemë',
    treesUnitK: 'K pemë',
    tonUnit: 'ton',
    kgUnit: 'kg',
    onlineCountLabel: 'Online',
    offlineCountLabel: 'Offline',
    capacityAbbrev: 'kap.',
    timeLabel: 'Koha',
    previousDayAria: 'Dita e mëparshme',
    nextDayAria: 'Dita e ardhshme',
    companyPagesAria: 'Faqet e kompanive',
    fleetOutputEyebrow: 'Dalja e flotës',
    liveOutput: 'Dalja live',
    totalCapacityLabel: 'Kapaciteti total',
    mwNowLabel: 'MW · TANI',
    ofCapacityPct: '% e {cap} MW',
    hybridEnergyAnalysis: 'Analizë hybrid',
    hybridEnergyAnalysisHint: 'Fikur = vetëm import/eksport. Ndezur = solar, ngarkesë, bateri me legjendë.',
    controlFailClosedBanner:
      'Vetëm kufiri i fuqisë së impiantit shkruhet te SmartLogger. Start, Stop, Enable dhe Shutdown mbeten të fikura. Fjalëkalimi kontrollohet para se komanda të dërgohet. Suksesi vjen pasi regjistri rilexohet.',
    platformCommandProbe: 'Probe komande Platform',
    platformProbing: 'Duke provuar…',
    solarEssTitle: 'Sistemi i Ruajtjes së Energjisë Solare',
    searchByLocation: 'Kërko sipas lokacionit...',
    noCompanyFound: 'Nuk u gjet asnjë kompani',
    mapLabel: 'Harta',
    energyProducedToday: 'Energjia e prodhuar sot',
    totalFromAllEnergyMeters: 'Totali nga të gjithë energy meterët',
    fromAllEnergyMeters: 'Nga të gjithë energy meterët',
    monthlyTrend: 'Tendenca mujore',
    productionByCompany: 'Prodhimi sipas kompanisë',
    producingNow: 'Duke prodhuar',
    pvNowAllCompaniesSum: 'PV tani — shuma e të gjitha kompanive',
    totalCompaniesCount: 'Kompani totale',
    pvNowTotal: 'PV tani (total)',
    energyProduced: 'Energjia prodhuar',
    fleetPower: 'Fuqia (flotë)',
    monthlyEnergy: 'Energjia mujore',
    monthToDateHint: '1 → sot (muaji)',
    installed: 'Instaluar',
    realtimeCurve: 'Kurba në kohë reale',
    periodDayShort: 'Ditë',
    periodMonthShort: 'Muaj',
    periodYearShort: 'Vit',
    periodTotal: 'Total',
    periodLifetime: 'Gjithë jeta',
    updatedAt: 'Përditësim',
    exportColCompany: 'Kompania',
    exportColDate: 'Data',
    exportColMeter: 'Energy Meter',
    exportColHour: 'Ora',
    exportColProductionKwh: 'Prodhimi (kWh)',
    exportColGhi: 'Rrezatimi GHI (W/m2)',
    exportColTempAmbient: 'Temp. Ambient (C)',
    exportColTempModule: 'Temp. Modul (C)',
    exportColWind: 'Era (m/s)',
    digitalTwinTitle: 'PV-01 · Binjaku Digjital i Impiantit Solar',
    digitalTwinSubtitle: 'SITE 04 / 66 kWp ARRAY / 11 kV UTILITY TIE',
    digitalTwinPvKw: 'PV kW',
    digitalTwinBatteryKw: 'Battery kW',
    digitalTwinGridKw: 'Grid kW',
    digitalTwinLoadKw: 'Load kW',
    digitalTwinLive: 'Live',
    digitalTwinAutoCycle: 'Cikël auto',
    digitalTwinManual: 'Manual',
    digitalTwinPowerFlowState: 'Gjendja e rrjedhës së fuqisë',
    digitalTwinSequence: 'Sekuenca',
    digitalTwinAutoCycleAll: 'Ciclo automatikisht të gjitha gjendjet',
    digitalTwinScenario: 'Skenari',
    digitalTwinTrackingLive: 'Duke ndjekur telemetrinë në kohë reale.',
    digitalTwinBatterySoc: 'Gjendja e ngarkesës së baterisë',
    digitalTwinMetering: 'Matja',
    digitalTwinDcBus: 'DC bus',
    digitalTwinAcBus: 'AC bus',
    digitalTwinFrequency: 'Frekuenca',
    digitalTwinPowerFactor: 'Faktori i fuqisë',
    digitalTwinSelfConsumption: 'Vetë-konsumi',
    digitalTwinStatus: 'Statusi',
    digitalTwinTwin: 'Binjaku',
    digitalTwinControlsHint: 'Orbit: tërhiq · Zoom: rrotë · Pan: klik djathtas.',
    digitalTwinLegendSolar: 'Gjenerim solar',
    digitalTwinLegendBattery: 'Shkarkim baterie',
    digitalTwinLegendGrid: 'Import rrjeti',
    digitalTwinLegendLoad: 'Ngarkesa e site-it',
    digitalTwinLegendOff: 'Pa energji',
    digitalTwinLiveTelemetry: 'TELEMETRI LIVE',
    digitalTwinDemoSequence: 'SEKUENCË DEMO',
    digitalTwinAlarmInvOk: 'Inverter INV-01 · duke punuar',
    digitalTwinAlarmCbOk: 'Combiner CB-01 · 6/6 stringje',
    digitalTwinAlarmStringWarn: 'String 3 · −4% devijim prodhimi',
    digitalTwinAlarmEssOk: 'ESS BMS · e balancuar',
    digitalTwinAlarmUtilityOk: 'Lidhja utility · e sinkronizuar',
    digitalTwinStateSolarLoad: 'Solar → Load',
    digitalTwinStateSolarBatt: 'Solar → Battery',
    digitalTwinStateSolarGrid: 'Solar → Grid',
    digitalTwinStateGridLoad: 'Grid → Load',
    digitalTwinStateBattLoad: 'Battery → Load',
    digitalTwinStateGridBatt: 'Grid → Battery',
    digitalTwinStateSolarBattLoad: 'Solar → Battery → Load',
    digitalTwinNoteSolarLoad: 'Dalja e array-it përputhet me kërkesën e site-it. Bateria në idle, pa shkëmbim me rrjetin.',
    digitalTwinNoteSolarBatt: 'Tepricë gjenerimi që ngarkon ESS. Kërkesa e site-it jashtë turnit.',
    digitalTwinNoteSolarGrid: 'Bateria plotë, ngarkesë e lehtë — teprica eksportohen përmes lidhjes 11 kV.',
    digitalTwinNoteGridLoad: 'Operim nate. Array jashtë, ESS në rezervë, rrjeti mban site-in.',
    digitalTwinNoteBattLoad: 'Shkarkim peak-shaving. Importi i rrjetit zero gjatë tarifës së pikut.',
    digitalTwinNoteGridBatt: 'Ringarkim jashtë pikut nga rrjeti para pikut të mëngjesit.',
    digitalTwinNoteSolarBattLoad: 'Array shërben site-in dhe ngarkon ESS njëkohësisht.',
    controlConfirmStop: 'A je i sigurt? Dëshiron të ndalësh inverterat e zgjedhur?',
    controlConfirmStart: 'A je i sigurt? Dëshiron të ndezësh inverterat e zgjedhur?',
    controlConfirmShutdown: 'A je i sigurt? Dëshiron të ndalësh të gjithë plantin?',
    controlConfirmEnable: 'A je i sigurt? Dëshiron të ndezësh/aktivizosh plantin?',
    controlConfirmLimitDisable: 'A je i sigurt? Dëshiron të hiqësh limitin e prodhimit?',
    controlConfirmLimitPercent: 'A je i sigurt? Do të aplikosh limit me %?',
    controlConfirmLimitKw: 'A je i sigurt? Do të aplikosh limit me kW?',
    controlConfirmReactive: 'A je i sigurt? Do të vendosësh Q (reaktiv) në kVar?',
    controlConfirmPf: 'A je i sigurt? Do të vendosësh Power Factor (cosφ)?',
    controlConfirmQMode: 'A je i sigurt? Do të ndërrosh mënyrën e kontrollit reaktiv?',
    controlSelectCompanyDl: 'Zgjidhni kompaninë dhe data logger.',
    controlInvalidPercent: 'Vendosni % të vlefshme (0–100).',
    controlInvalidKw: 'Vendosni kW të vlefshme.',
    controlInvalidKvar: 'Vendosni vlerë kVar të vlefshme (p.sh. -50, 0, +50).',
    controlInvalidPf: 'Vendosni PF të vlefshme (0.80–1.00 ose -1.00–1.00).',
    controlInvalidMode: 'Zgjidhni mënyrë të vlefshme.',
    'cmdOutcome.executed': 'Ekzekutuar dhe verifikuar.',
    'cmdOutcome.pendingApproval': 'Në pritje të miratimit nga një person tjetër. Asgjë nuk është dërguar ende te impianti.',
    'cmdOutcome.received': 'Pranuar nga gateway, në pritje të ekzekutimit.',
    'cmdOutcome.dispatched': 'Komanda u dërgua te gateway.',
    'cmdOutcome.approved': 'Komanda u miratua; po dërgohet te gateway.',
    'cmdOutcome.requested': 'Komanda u regjistrua (requested).',
    'cmdOutcome.rejected': 'Komanda u refuzua.',
    'cmdOutcome.cancelled': 'Komanda u anulua.',
    'cmdOutcome.failedOrExpired': 'Komanda {status}.',
    'cmdOutcome.statusFailed': 'dështoi',
    'cmdOutcome.statusExpired': 'skadoi',
    'cmdOutcome.unknown': 'Status i panjohur i komandës: {status}.',
    'cmdOutcome.reasonPrefix': 'Arsyeja: {reason}',
    'cmdOutcome.idPrefix': 'ID: {id}',
    'cmdOutcome.expiresAt': 'Skadon: {time}',
    'cmdOutcome.register': 'Regjistri: {register}',
    'cmdOutcome.address': 'Adresa: {address}',
    'cmdOutcome.valueWritten': 'Shkruar: {values}',
    'cmdOutcome.valueRead': 'Lexuar: {values}',
    'cmdReason.approval_timeout': 'Afati i miratimit skadoi pa përgjigje.',
    'cmdReason.no_edge_ack': 'Gateway nuk e pranoi komandën brenda afatit (~30 s).',
    'cmdReason.no_execution_confirmation': 'Nuk u mor konfirmim i ekzekutimit (~120 s).',
    'cmdReason.edge_commands_disabled': 'Komandat janë të fikura në gateway.',
    'cmdReason.unsupported_command': 'Lloji i komandës nuk mbështetet në gateway.',
    'cmdReason.replay': 'Komanda u refuzua (replay / e përsëritur).',
    'cmdReason.signature_invalid': 'Nënshkrimi i komandës është i pavlefshëm.',
    'cmdReason.expired': 'Komanda skadoi para ekzekutimit.',
    'cmdReason.commands_disabled': 'Komandat e platformës janë të fikura.',
    'cmdReason.self_approval_forbidden': 'Nuk mund ta miratoni komandën tuaj — duhet një person tjetër.',
    'cmdReason.invalid_state': 'Gjendja e komandës nuk lejon këtë veprim.',
    'cmdReason.invalid_credentials': 'Fjalëkalimi është i gabuar.',
    'cmdReason.password_check_unavailable': 'Verifikimi i fjalëkalimit nuk është i disponueshëm.',
    'cmdStep.requested': 'Kërkuar',
    'cmdStep.approval': 'Miratimi',
    'cmdStep.dispatched': 'Dërguar te gateway',
    'cmdStep.received': 'Pranuar nga gateway',
    'cmdStep.executed': 'Ekzekutuar dhe verifikuar',
    'cmdUi.lifecycleTitle': 'Gjendja e komandës',
    'cmdUi.refreshStatus': 'Rifresko statusin',
    'cmdUi.pendingTitle': 'Miratime në pritje',
    'cmdUi.pendingEmpty': 'Nuk ka komanda që presin miratim.',
    'cmdUi.recentTitle': 'Komanda të fundit',
    'cmdUi.recentEmpty': 'Ende nuk ka histori komandash.',
    'cmdUi.requestedBy': 'Kërkuar nga',
    'cmdUi.timeLeft': 'Kohë e mbetur',
    'cmdUi.approveAction': 'Mirato',
    'cmdUi.rejectAction': 'Refuzo',
    'cmdUi.cancelAction': 'Anulo',
    'cmdUi.approveTitle': 'Konfirmo miratimin',
    'cmdUi.rejectTitle': 'Refuzo komandën',
    'cmdUi.rejectReasonLabel': 'Arsyeja e refuzimit',
    'cmdUi.rejectReasonPlaceholder': 'Shkruani arsyen…',
    'cmdUi.rejectReasonRequired': 'Arsyeja e refuzimit është e detyrueshme.',
    'cmdUi.selfApprovalForbidden': 'Nuk mund ta miratoni komandën tuaj — duhet një person tjetër.',
    'cmdUi.invalidCredentials': 'Fjalëkalimi është i gabuar.',
    'cmdUi.approveSuccess': 'Komanda u miratua dhe u dërgua.',
    'cmdUi.approveFailed': 'Miratimi dështoi.',
    'cmdUi.rejectSuccess': 'Komanda u refuzua.',
    'cmdUi.rejectFailed': 'Refuzimi dështoi.',
    'cmdUi.cancelSuccess': 'Komanda u anulua.',
    'cmdUi.cancelFailed': 'Anulimi dështoi.',
    'cmdUi.secondsLeft': '{sec} s',
    'cmdUi.minutesLeft': '{min} min {sec} s',
    'cmdUi.expiredNow': 'Skadoi',
  },
  en: {
    logout: 'Logout',
    tgSeeded: '{n} tags seeded from {profile}',
    tgThresholdsToast: 'Thresholds: {name}',
    tgThresholdsErr: 'Thresholds: {detail}',
    tgEnableReads: 'Enable reads',
    tgApplyFieldSafe: 'Apply field-safe',
    tgAlarmThresholds: 'Alarm thresholds',
    egDraftCreated: 'Draft created ({id})',
    egSkipped: 'Sync skipped devices without enabled tags: {keys}',
    egPublished: 'Draft + publish done (Sync edge)',
    egDraftEdge: 'Edge draft created',
    egQueue: 'Queue',
    egQueueTitle: 'Edge queue',
    egBatch: 'batch',
    ddTime: 'Time',
    ddPlantProduction: 'Plant production',
    ddLogger: 'Logger',
    ddReactivePower: 'Reactive power',
    ddPowerFactor: 'Power factor',
    ddEnergyToday: 'Energy today',
    ddEnergyTotal: 'Total energy',
    ddCapacity: 'Capacity',
    ddAlarmHistory: 'Alarm history',
    ddInverterPrefix: 'Inverter',
    ddOpen: 'OPEN →',
    ddEnergyAnalysis: 'Energy analysis',
    ddActualLoad: 'Actual load',
    ddNoComm: 'No communication',
    ddKpiActivePower: 'ACTIVE POWER',
    ddKpiToday: 'TODAY',
    ddKpiRatedAc: 'RATED AC',
    ddKpiActiveAlarms: 'ACTIVE ALARMS',
    ddCommunication: 'Communication',
    ddPhoto: 'Photo',
    ddUploadPhoto: 'Upload photo',
    ddErrPhoto: 'Error uploading the photo',
    ddHistory: 'History',
    ddEnergy: 'Energy',
    ddNeutral: 'Neutral',
    ddPrevious: 'Previous',
    ddNext: 'Next',
    ddPeriod_day: 'Day',
    ddPeriod_week: 'Week',
    ddPeriod_month: 'Month',
    ddPeriod_year: 'Year',
    ddPeriod_lifetime: 'Lifetime',
    ddParamsEyebrow: 'PROXNOVA / PARAMETERS',
    ddParamsTitle: 'Detailed parameters',
    ddNoLiveTelemetry: 'No live telemetry yet — showing placeholders.',
    ddReadingsFromDevice: 'Readings from the device (live / historian).',
    tgTitle: 'Modbus measurements',
    tgActiveCount: 'active',
    tgAddTag: '+ Tag',
    tgCancel: 'Cancel',
    tgEnableAllTitle: 'Enable all read registers (holding/input); coils stay off',
    tgFieldSafeTitle: 'Only tags verified in the field (min profile)',
    tgNoTagsSeed: 'No tags — the edge does not poll this device until they are seeded from a driver profile.',
    tgPickProfile: 'Select a profile…',
    tgActiveRead: 'Active (read by the edge)',
    tgAlarmHint: 'Raises an alarm when the value leaves the range',
    tgLowThreshold: 'Low threshold',
    tgHighThreshold: 'High threshold',
    tgLowTitle: 'Minimum value — below this raises an alarm',
    tgHighTitle: 'Maximum value — above this raises an alarm',
    tgSaveTag: 'Save tag',
    tgLoading: 'Loading…',
    tgNoTags: 'No tags for this device.',
    tgThresholds: 'Thresholds',
    tgClose: 'Close',
    tgDisableTitle: 'Disable (remove from the edge)',
    tgEnableTitle: 'Enable (add to the edge)',
    tgSaveThresholds: 'Save thresholds',
    tgErrToggle: 'Toggle failed: {detail}',
    tgErrEnableAll: 'Enabling reads failed: {detail}',
    tgErrFieldSafe: 'Field-safe failed: {detail}',
    tgErrPickProfile: 'Select a driver profile to seed',
    tgErrSeed: 'Seed failed: {detail}',
    tgErrNameAddr: 'Name and address are required',
    tgErrAdd: 'Adding failed: {detail}',
    egErrDraft: 'Draft failed: {detail}',
    egErrPublish: 'Publish failed: {detail}',
    egHealed: 'Tags repaired: {tags}',
    egPublishDisabled: 'Publish is disabled in the API',
    egErrSync: 'Edge sync failed: {detail}',
    egOneStep: 'Draft + publish in one step',
    egClose: 'Close',
    egQuotaFull: 'quota full',
    egQuotaWarn: 'quota warning',
    egAgo: '{age} ago',
    egHint: 'Publish → MQTT desired. Enabling on the edge requires EDGE_AGENT_CONFIG_APPLY_ENABLE=true.',
    dpAllStatuses: 'All statuses',
    dpSearchPlaceholder: 'Search device or serial…',
    dpSearchAria: 'Search devices',
    dpStatusFilterAria: 'Filter by status',
    dpColStatus: 'STATUS',
    dpColDevice: 'DEVICE',
    dpColType: 'TYPE',
    dpColPower: 'POWER',
    dpColActions: 'ACTIONS',
    dpLblStatus: 'Status',
    dpLblDevice: 'Device',
    dpLblType: 'Type',
    dpLblPower: 'Power',
    dpLblActions: 'Actions',
    dpAutoProfile: 'Auto from brand/model',
    dpTags: 'tags',
    dpProfileHint: 'Changing Huawei ↔ Sungrow (etc.) and pressing Save re-seeds the tags and sends them to the Pi. Tag list: below under “Modbus tags”.',
    dpIpPlaceholderChint: '0.0.0.0 or a label',
    dpBulkLogger: 'Automatically create inv-001…inv-N (different COM units)',
    dpBulkInverter: 'Create many inverters (COM units 1…N)',
    dpUnitFrom: 'Unit from',
    dpUnitTo: 'Unit to',
    dpTransform: 'Transform',
    dpTransformHint: 'Scales the Chint total forward/reverse kWh before storage. Default 1.',
    dpSchemeCommNote: 'Communication, not energy',
    dpSchemeFooter: 'This is not an electrical design for installation.',
    dpEmptyHint: 'Try a different name or change the status filter.',
    dpErrNetwork: 'Could not reach the server. Check that the backend is running.',
    dpErrDelete: 'Error while deleting',
    dpPickCompany: 'Select a company!',
    dpPickLogger: 'Select a Data Logger!',
    dpTagsReseeded: '{n} tags re-seeded ({profile})',
    dpInvertersCreated: '{n} inverters created ({skipped} existing)',
    dpInvertersCreatedRange: '{n} inverters created ({from}…{to})',
    dpTagsSeeded: '{n} Modbus tags seeded',
    dpTagsSeededInverters: '{n} Modbus tags seeded for the inverters',
    dpTagsLoaded: '{n} tags loaded from the driver profile',
    dpEdgeSent: 'Configuration sent to the edge agent',
    dpEdgeDraft: 'Edge config drafted; publish is disabled in the API',
    dpPhoto401: 'Photo: you are not signed in or the token expired. Sign out and sign in again.',
    dpPhoto404: 'Photo: the endpoint or device was not found. Check that the backend is up to date (restart it).',
    dpPhoto405: 'Photo: Method Not Allowed. The backend must be rebuilt (stop and restart the server).',
    dpPhoto500: 'Photo: server error: {detail}',
    dpPhotoFail: 'The photo was not saved ({status}): {detail}',
    dpNetwork: 'network',
    dpUpdated: 'Device updated!',
    dpAdded: 'Device added!',
    dpError: 'Error',
    dvPreviewTitle: 'Device measurements',
    dvPreviewEyebrow: 'DEVICE MEASUREMENTS',
    dvCloseDetails: 'Close details',
    dvFullDetails: 'Full details',
    dvRowCompany: 'Company',
    dvRowType: 'Type',
    dvRowBrand: 'Brand',
    dvRowModel: 'Model',
    dvRowSerial: 'Serial',
    dvRowStatus: 'Status',
    dvRowPower: 'Active power',
    dvEmptyHint: 'Try a different name or change the status filter.',
    dvUnitIdInUse: 'This Unit ID is already in use on this Data Logger.',
    monLiveTitle: 'Live Monitoring of Solar Plants',
    monLiveTitleCompany: 'Live Monitoring · {name}',
    noPermission: 'Not allowed',
    settings: 'Settings',
    reportNeedDates: 'Set the start and the end.',
    reportGenerateFirst: 'Generate the report before downloading it.',
    popupBlocked: 'Allow the new window for the PDF.',
    pdfReady: 'PDF generated successfully.',
    rvNoData: 'Not enough data.',
    rvChartDays: 'Production per day',
    rvChartYear: 'This year and last year',
    rvLegendYear: 'cyan this year · blue last year',
    rvFlowBalance: 'Flow balance',
    rvChartHourly: 'Production by hour',
    rvLegendTomorrow: 'kWh · tomorrow',
    rvChartPower: 'Power during the day',
    rvLegendHour: 'kW · hour',
    rvInverters: 'Inverters',
    rvNr: 'No.',
    rvMonth_0: 'Jan',
    rvMonth_1: 'Feb',
    rvMonth_2: 'Mar',
    rvMonth_3: 'Apr',
    rvMonth_4: 'May',
    rvMonth_5: 'Jun',
    rvMonth_6: 'Jul',
    rvMonth_7: 'Aug',
    rvMonth_8: 'Sep',
    rvMonth_9: 'Oct',
    rvMonth_10: 'Nov',
    rvMonth_11: 'Dec',
    abSummary: 'ProxNova SCADA is an industrial platform for real-time monitoring, automation and management of processes. The platform integrates inverters, PLCs, Data Loggers, energy meters, sensors and industrial systems in a single centralized environment.',
    abMobileSummary: 'Industrial platform for real-time monitoring, control and management of energy and industrial systems.',
    abDoc_brochure_title: 'ProxNova SCADA 2026 brochure',
    abDoc_brochure_text: 'Introduction to the platform and its modules.',
    abDoc_manual_title: 'User manual',
    abDoc_manual_text: 'Using the modules.',
    abDoc_install_title: 'Installation guide',
    abDoc_install_text: 'Installation and startup.',
    abDoc_tech_title: 'Technical documentation',
    abDoc_tech_text: 'Architecture and integrations.',
    abDoc_notes_title: 'Release notes',
    abDoc_notes_text: 'Summary of releases.',
    'abVer_2.3_note': 'The full package of the current interface.',
    'abVer_2.2_g0_title': 'Design improvements',
    'abVer_2.2_g0_i0_title': 'Pop-ups',
    'abVer_2.2_g0_i0_text': 'The background behind dialogs is blurred, the same on desktop and mobile.',
    'abVer_2.2_g0_i1_title': 'Add Device',
    'abVer_2.2_g0_i1_text': 'On mobile the dialog stays in the middle of the screen.',
    'abVer_2.0_g0_title': 'New features',
    'abVer_2.0_g0_i0_title': 'Reports',
    'abVer_2.0_g0_i0_text': 'Production, finance, analysis, batteries, technical and executive reports, with preview and PDF.',
    'abVer_2.0_g0_i1_title': 'Financial configuration',
    'abVer_2.0_g0_i1_text': 'Investment, loans, tariffs and calculation from the entered values.',
    'abVer_2.0_g0_i2_title': 'Planning',
    'abVer_2.0_g0_i2_text': 'Hour-by-hour comparison and the forecast document.',
    'abVer_2.0_g0_i3_title': 'Alarms',
    'abVer_2.0_g0_i3_text': 'Active alarms, history and notifications.',
    'abVer_2.0_g0_i4_title': 'Resources and support',
    'abVer_2.0_g0_i4_text': 'Documentation and manuals.',
    'abVer_2.0_g1_title': 'Improvements',
    'abVer_2.0_g1_i0_title': 'Company on top',
    'abVer_2.0_g1_i0_text': 'The company selection filters the open page.',
    'abVer_2.0_g1_i1_title': 'Appearance',
    'abVer_2.0_g1_i1_text': 'Dark and light theme in the portal.',
    'abVer_2.0_g2_title': 'Design improvements',
    'abVer_2.0_g2_i0_title': 'Documents',
    'abVer_2.0_g2_i0_text': 'Reports use the same document on screen and in the PDF.',
    'abVer_2.0_g2_i1_title': 'Account',
    'abVer_2.0_g2_i1_text': 'The account menu is organized by groups.',
    'abVer_1.02_note': 'No notes have been published for this version.',
    abDocsTitle: 'Documentation & Downloads',
    abNotLoaded: 'The document has not been uploaded yet',
    abViewDoc: 'View document',
    abDownloadPdf: 'Download PDF',
    abWhatsNew: "What's new?",
    abVersionHistory: 'Version history',
    abContactSupport: 'Contact & Support',
    abVersionsUpdates: 'Versions and updates',
    abDocuments: 'Documents',
    abContactSupportM: 'Contact and support',
    abDeveloper: 'Developer',
    abPlatform: 'Platform',
    abPhone: 'Phone',
    abPhoneShort: 'Phone',
    asTitle: 'Automatic delivery',
    asSubtitle: 'Configure periodic reports by email',
    asAdminOnly: 'Only the administrator configures automatic delivery.',
    asAdminOnlySave: 'Only the administrator saves deliveries.',
    asPickFreq: 'Select at least one frequency.',
    asPickWeekday: 'Select the day of the week.',
    asPickMonthday: 'Select the day of the month.',
    asPickRecipient: 'Select at least one recipient.',
    asDuplicate: 'This delivery already exists and was not added again.',
    asActivated: 'Delivery activated.',
    asDeactivated: 'Delivery deactivated.',
    asConfirmRemove: 'This delivery will be removed from the list.',
    asChangesSaved: 'Changes saved successfully.',
    asConfigTitle: 'Delivery configuration',
    asFrequency: 'Frequency',
    asDaily: 'Daily',
    asWeekly: 'Weekly',
    asMonthly: 'Monthly',
    asWeekday: 'Day of the week',
    asPickDay: 'Select the day',
    asMonthday: 'Day of the month',
    asSendTime: 'Delivery time',
    asTimezone: 'Time zone',
    asRecipientsTitle: 'Report recipients',
    asSelected: 'selected',
    asNoUsers: 'There are no users for this company.',
    asSaveSchedule: 'Save delivery',
    asConfigured: 'Configured deliveries',
    asNone: 'No saved deliveries.',
    asColReport: 'Report',
    asColHour: 'Time',
    asColRecipients: 'Recipients',
    asHint: 'The schedule is stored locally (as in V2). Real email delivery is enabled when the server has `report_schedules` + SMTP — the configuration stays the same.',
    asDay_1: 'Monday',
    asDay_2: 'Tuesday',
    asDay_3: 'Wednesday',
    asDay_4: 'Thursday',
    asDay_5: 'Friday',
    asDay_6: 'Saturday',
    asDay_7: 'Sunday',
    finTitle: 'Financial configuration',
    finSubtitle: 'Plant financial parameters',
    finNoPermission: 'You do not have permission for the financial configuration.',
    finNoPermissionEdit: 'You do not have permission to change the financial configuration.',
    finPickCompany: 'Select a company.',
    finTariffNeedsDate: 'A new tariff requires a start date.',
    finInvoiceNeedsMonth: 'A new invoice requires the month.',
    finNotSaved: 'The configuration was not saved.',
    finSyncFailed: 'Finance was saved locally; the tariff sync to the API failed (check permissions/token).',
    finSaved: 'Configuration saved.',
    finNetInvestment: 'Net investment (€)',
    finAfterSubsidy: 'After subsidies',
    finLoanFinancing: 'Loan financing (€)',
    finLoanSum: 'Loan amount',
    finCapacityInstalled: 'Installed capacity (kWp)',
    finFromSaved: 'From the saved value',
    finAccInvest: 'Investment',
    finAccInvestSub: 'Panels, inverters, installation, batteries, subsidies',
    finPanels: 'Panels',
    finInverters: 'Inverters',
    finInstall: 'Installation',
    finBattery: 'Battery',
    finOther: 'Other',
    finSubsidy: 'Subsidies',
    finTotalInvestment: 'Total investment',
    finTotalHint: 'Panels + inverters + installation + battery + other',
    finCapacityKwp: 'Capacity (kWp)',
    finInvestedOn: 'Investment date',
    finOperatedOn: 'Operation start',
    finHasBattery: 'Has configured batteries',
    finBatKwh: 'Capacity (kWh)',
    finBatPower: 'Power (kW)',
    finBatChem: 'Battery chemistry',
    finAccLoan: 'Loans and financing',
    finAccLoanSub: 'Loan, interest, installment, term and payments',
    finLoanAmount: 'Amount',
    finLoanBank: 'Bank',
    finLoanRate: 'Rate',
    finLoanTerm: 'Term',
    finMonths: 'months',
    finLoanInstallment: 'Monthly installment',
    finLoanStart: 'Start',
    finLoanPaidCount: 'Installments paid',
    finLoanPaidPrincipal: 'Principal paid',
    finLoanExtra: 'Extra payment',
    finLoanStatus: 'Status',
    finRemove: 'Remove',
    finAddLoan: 'Add loan',
    finAccTariff: 'Energy tariffs',
    finAccTariffSub: 'Import, export, day/night tariffs',
    finTariffLine: '{from} · purchase {import} · export {export}',
    finNoTariffs: 'No tariffs.',
    finTDate: 'Date',
    finTBuy: 'Purchase',
    finTExport: 'Export',
    finTDay: 'Day',
    finTNight: 'Night',
    finTPeak: 'Peak',
    finTFixed: 'Fixed',
    finTScheme: 'Scheme',
    finTariffHint: 'The new tariff is added to the list when you save. Active tariff = the latest dated ≤ today. The purchase tariff is synced to the API `tariff_eur_per_kwh` for the dashboard profit.',
    finAccInvoice: 'Monthly invoices',
    finAccInvoiceSub: 'Actual invoices and energy expenses',
    finColMonth: 'Month',
    finColEnergy: 'Energy',
    finColTotal: 'Total',
    finColPaid: 'Paid',
    finColActions: 'Actions',
    finNoInvoices: 'No invoices.',
    finDelete: 'Delete',
    finITaxes: 'Taxes',
    finICredit: 'Credit',
    finIPaidOn: 'Payment date',
    finIRef: 'Reference',
    finAccAnalysis: 'Financial analysis',
    finAccAnalysisSub: 'Savings and cash flow from the entered values',
    finPvProduction: 'PV production',
    finSelfConsumption: 'Self-consumption',
    finExport: 'Export',
    finImport: 'Import',
    finOpex: 'Operating expenses',
    finDiscount: 'Discount rate',
    finAnnualFlows: 'Annual flows',
    finKpiSavings: 'Savings',
    finKpiExport: 'Export',
    finKpiOperating: 'Operating profit',
    finKpiAfterInstallment: 'After installment',
    finKpiPayback: 'Payback',
    finYears: 'years',
    finMissing: 'Missing: {items}.',
    finMiss_tarifat: 'tariffs',
    finMiss_energjia: 'energy',
    'finMiss_shpenzimet operative': 'operating expenses',
    finFormula: 'Formula: savings = self-consumption × purchase tariff; export € = exported kWh × export tariff; operating = savings + export € − opex; cash = operating − installment (if there is a loan).',
    finNoAudit: 'No saved changes.',
    finAuditLine: 'version',
    finDirty: 'You have unsaved changes.',
    finSave: 'Save configuration',
    finSaving: 'Saving…',
    finImpactTitle0: 'Purchase tariff (€/kWh)',
    finImpactText0: 'Savings = self-consumption (kWh) × purchase tariff. It is the avoided cost of grid energy.',
    finImpactTitle1: 'Export tariff (€/kWh)',
    finImpactText1: 'Export income = exported kWh × export tariff. It is not counted twice with the savings.',
    finImpactTitle2: 'PV production',
    finImpactText2: 'Not treated as direct profit. Used for balance and production reports; profit comes from self-consumption + export.',
    finImpactTitle3: 'OPEX',
    finImpactText3: 'Deducted from (savings + export €) to give the operating profit.',
    finImpactTitle4: 'Loan installment',
    finImpactText4: 'Deducted once from the operating profit → cash flow after installment. Without a loan, cash = operating.',
    finImpactTitle5: 'Investment / subsidy',
    finImpactText5: 'Net = gross − subsidies. Used for payback (years) = investment / operating profit.',
    finImpactTitle6: 'Capacity (kWp) & battery',
    finImpactText6: 'kWp: the plant target. hasBattery enables the B reports; without the flag, battery reports do not invent devices.',
    finImpactTitle7: 'Invoices',
    finImpactText7: 'Invoiced credit and collected payments for the F reports — separate from the operating tariff calculation.',
    usRolesTitle: 'Roles & privileges',
    usReadOnly: 'read-only',
    usEditRole: 'Edit role',
    usNewRoleTitle: 'New role',
    usRoleName: 'Name',
    usPermissions: 'Permissions',
    usRoleNoEdit: 'Platform roles cannot be edited',
    usRoleNoDelete: 'Platform roles cannot be deleted',
    usRoleSaved: 'Role saved',
    usRoleSaveFail: 'Role save failed',
    usRoleDeleteTitle: 'Delete role',
    usRoleDeleteMsg: 'Delete role "{name}"? Users with only this role may lose access.',
    usRoleDeleted: 'Role deleted',
    usDeleteFail: 'Delete failed',
    mdPasswordIdp1: 'Passwords are managed by the identity provider (SSO / oidc-lab). The Platform API does not store credentials.',
    mdPasswordIdp2: 'Use your account settings in the IdP to change it.',
    mdSettingsNote: 'Language, appearance and security',
    mdAboutNote: 'Version and contact',
    mdLogoutNote: 'End the session',
    cnKicker: 'PROXNOVA / ADMINISTRATION',
    cnSearchPlaceholder: 'Search gateway / site / device',
    cnSearchAria: 'Search connections',
    cnAdd: 'Add gateway',
    cnEdit: 'Edit',
    cnColSync: 'Sync',
    cnFormEdit: 'Edit gateway',
    cnClose: 'Close',
    cnFormHint: 'One box (Raspberry) per gateway. All use the same MQTT broker; they are told apart by external id.',
    cnPickSite: 'Select site…',
    cnName: 'Name',
    cnMqttPassword: 'MQTT password',
    cnPwKeep: 'empty = unchanged',
    cnPwOptional: 'optional',
    cnActive: 'Active',
    cnCancel: 'Cancel',
    cnSaving: 'Saving…',
    cnSave: 'Save',
    cnErrRequired: 'Site, name and external id are required.',
    cnErrSave: 'Saving failed.',
    'usNav_/dashboard': 'Dashboard',
    'usNav_/devices': 'Devices',
    'usNav_/monitoring': 'Monitoring',
    'usNav_/alarms': 'Alarms',
    'usNav_/reports': 'Reports',
    'usNav_/analysis': 'Analysis',
    'usNav_/production-planning': 'Planning',
    'usNav_/control': 'Control',
    'usNav_/users': 'Users',
    'usNav_/companies': 'Companies',
    'usNav_/connections': 'Connections',
    'usNav_/platform-lab': 'Platform Lab',
    'usNav_/me': 'Profile',
    usKicker: 'PROXNOVA / ADMINISTRATION',
    usNewRole: 'New role',
    usNew: 'New user',
    usHide: 'Hide',
    usShow: 'Show',
    usSearchPlaceholder: 'Search users (name, username, email)',
    usSearchAria: 'Search users',
    usRoleFilter: 'Role filter',
    usAllRoles: 'All roles',
    usCompanyFilter: 'Company filter',
    usAllCompanies: 'All companies',
    usStatusFilter: 'Status filter',
    usAllStatuses: 'All statuses',
    usActive: 'Active',
    usInactive: 'Inactive',
    usNotFound: 'No user found.',
    usMore: 'More',
    usView: 'View',
    usEdit: 'Edit',
    usChangeRole: 'Change role',
    usDeactivate: 'Deactivate',
    usActivate: 'Activate',
    usDelete: 'Delete',
    usNotAllowed: 'Not allowed',
    usChange: 'Change',
    usColName: 'Name',
    usColRole: 'Role',
    usColCompany: 'Company',
    usColStatus: 'Status',
    usColActions: 'Actions',
    usPagerAria: 'User pages',
    usPerPage: 'Users per page',
    usOf: 'of',
    usDetailsTitle: 'User details',
    usClose: 'Close',
    usEditTitle: 'Edit user',
    usFieldFullName: 'Full name *',
    usFieldPassword: 'Password *',
    usFieldConfirm: 'Confirm password *',
    usFieldRole: 'Role *',
    usFieldStatus: 'Status *',
    usHidePassword: 'Hide password',
    usShowPassword: 'Show password',
    usCompanyAccess: 'Companies with access',
    usCompanyInputPlaceholder: 'Type the company name...',
    usNoCompany: 'No company found.',
    usHint: 'Select the companies this user can access. The password is used to sign in.',
    usNavigation: 'Navigation',
    usCancel: 'Cancel',
    usSave: 'Save',
    usErrNetworkShort: 'Could not reach the server.',
    usErrList: 'Error loading the list.',
    usErrPwLen: 'The password must be at least 8 characters.',
    usErrPwMatch: 'The passwords do not match.',
    usWarnNoSite: 'The user was saved, but these companies have no site on the platform (site_access was not granted): {names}',
    usErrNetwork: 'Could not reach the server. Check that the backend is running.',
    usErrSave: 'Error while saving.',
    usErrDelete: 'Error while deleting.',
    usConfirmDeleteTitle: 'Confirm deletion',
    usConfirmDeleteMsg: 'Are you sure you want to delete this user?',
    usNo: 'No',
    usActivated: 'User activated.',
    usDeactivated: 'User deactivated.',
    usErrStatus: 'Error changing the status.',
    cpUploadLogo: 'Upload logo',
    cpKicker: 'PROXNOVA / ADMINISTRATION',
    cpNew: 'New company',
    cpEditTitle: 'Edit company',
    cpSearchPlaceholder: 'Search companies (name, location)',
    cpSearchAria: 'Search companies',
    cpStatusFilter: 'Status filter',
    cpAll: 'All',
    cpActive: 'Active',
    cpInactive: 'Inactive',
    cpNotFound: 'No company found.',
    cpMore: 'More',
    cpView: 'View',
    cpEdit: 'Edit',
    cpChange: 'Change',
    cpDelete: 'Delete',
    cpActivate: 'Activate',
    cpDeactivate: 'Deactivate',
    cpColName: 'Name',
    cpColLocation: 'Location',
    cpColPhone: 'Phone',
    cpColUnique: 'Unique No.',
    cpColStatus: 'Status',
    cpColActions: 'Actions',
    cpPagerAria: 'Company pages',
    cpOf: 'of',
    cpPerPage: 'Companies per page',
    cpDetailsTitle: 'Company details',
    cpClose: 'Close',
    cpLogo: 'Logo',
    cpUploadLogoAria: 'Upload logo',
    cpLogoHold: 'Press and hold for 3 seconds to upload a logo (PNG)',
    cpFieldName: 'Company name *',
    cpFieldStatus: 'Status *',
    cpFieldLocation: 'Location *',
    cpFieldPhone: 'Phone *',
    cpFieldVat: 'VAT No.',
    cpFieldLat: 'Latitude (lat)',
    cpFieldLon: 'Longitude (lon)',
    cpPlaceholderEg: 'e.g.',
    cpCancel: 'Cancel',
    cpSave: 'Save',
    cpUploadLogoTitle: 'Upload logo',
    cpPickPng: 'Choose a PNG image (transparent background) for the company logo.',
    cpBack: 'Back',
    cpUploading: 'Uploading...',
    cpPickPhoto: 'Choose photo',
    cpDeleteTitle: 'Delete company?',
    cpDeleteMsg: 'Do you want to remove the company {name}? This action cannot be undone.',
    cpErrPhotoSave: 'Error saving the photo:',
    cpErrSavedPhotoFailed: 'The company was saved, but the dashboard photo failed to upload:',
    cpErrNetwork: 'Could not reach the server. Check that the backend is running.',
    cpErrDelete: 'Error deleting the company.',
    cpErrLogoSize: 'The logo must be smaller than 2MB.',
    cpActivated: 'Company activated.',
    cpDeactivated: 'Company deactivated.',
    cpErrStatus: 'Error changing the status.',
    planKicker: 'PROXNOVA / OPERATIONS',
    planTitle: 'Production Planning',
    planPlant: 'Plant',
    planDateHistory: 'Date (history)',
    planDate: 'Date',
    planGenerate: 'Generate',
    planDownloadPdf: 'Download PDF',
    planTabForecast: 'Forecast',
    planTabCompare: 'Comparison',
    planHint: 'Select a company and press Generate.',
    planYesterday: 'Yesterday',
    planTomorrow: 'Tomorrow',
    planHourlyHistory: 'Hourly history',
    planForecastTomorrow: "Tomorrow's forecast",
    planForecastTotal: 'Forecast total',
    planHours: 'Hours',
    planColHour: 'Hour',
    planColWind: 'Wind m/s',
    planTotal: 'Total',
    planCompareTitle: 'Planning comparison',
    planForecastTitle: 'Production forecast (P05)',
    planPeriod: 'Period',
    repGenerated: 'Generated',
    repProdTotal: 'Total production',
    repProdByCompany: 'Production by company (MWh)',
    repProdMwh: 'Production (MWh)',
    repTotal: 'Total',
    repDocTitle: 'Report',
    repDocTo: 'to',
    repDocFleet: 'Consolidated report',
    repDocEnergy: 'Energy report',
    repIndicator: 'Indicator',
    repValue: 'Value',
    repKicker: 'PROXNOVA / ADMINISTRATION',
    repTitle: 'Reports',
    repSubtitle: 'Energy reports for operations, billing and management.',
    repTabBuild: 'Generate',
    repTabBuildNote: 'Create new reports',
    repTabHistory: 'History',
    repTabHistoryNote: 'View and manage',
    repTabFinanceFull: 'Financial configuration',
    repTabFinanceShort: 'Finance',
    repTabFinanceNote: 'Parameters and calculations',
    repTabAutoFull: 'Automatic delivery',
    repTabAutoShort: 'Delivery',
    repTabAutoNote: 'Schedule deliveries',
    repCompany: 'Company',
    repPlant: 'Plant',
    repCategory: 'Category',
    repType: 'Report type',
    repAll: 'All',
    repPeriod: 'Period',
    repPeriodToday: 'Today',
    repPeriodYesterday: 'Yesterday',
    repPeriodMonth: 'This month',
    repPeriodLastMonth: 'Last month',
    repPeriodYear: 'This year',
    repPeriodCustom: 'Custom range',
    repCompare: 'Comparison',
    repCompareNone: 'No comparison',
    repComparePrev: 'Previous period',
    repCompareYoy: 'Previous year',
    repFrom: 'From',
    repTo: 'To',
    repTomorrowOnly: 'This report only covers tomorrow.',
    repGenerating: 'Generating…',
    repGenerate: 'Generate report',
    repDownloadPdf: 'Download PDF',
    repDownloadExcel: 'Download Excel',
    repDelete: 'Delete',
    repChooseParams: 'Choose the parameters and generate the report.',
    repDateFrom: 'Start date',
    repDateTo: 'End date',
    repFleetAll: 'Fleet · all',
    repSearch: 'Search',
    repColReport: 'Report',
    repColGenerated: 'Generated',
    repColActions: 'Actions',
    repCat_P: 'Production',
    repCat_F: 'Finance',
    repCat_A: 'Analysis',
    repCat_B: 'Batteries',
    repCat_T: 'Technical reports',
    repCat_E: 'Executive reports',
    repType_P01: 'Daily production',
    repType_P02: 'Monthly production',
    repType_P03: 'Yearly production',
    repType_P04: 'Energy balance',
    repType_P05: 'Tomorrow forecast',
    repType_F01: 'Monthly financial summary',
    repType_F02: 'Investment and return',
    repType_F03: 'Loan and installments',
    repType_F04: 'Cash Flow',
    repType_F05: 'NPV, IRR and scenarios',
    repType_A01: 'Period comparison',
    repType_A02: 'Performance vs. expectations',
    repType_A03: 'Self-consumption and independence',
    repType_A04: 'Losses and anomalies',
    repType_B01: 'Battery operation',
    repType_B02: 'Efficiency and health',
    repType_B03: 'Financial contribution',
    repType_T01: 'Availability and outages',
    repType_T02: 'Alarms and events',
    repType_T03: 'Devices and maintenance',
    repType_E01: 'Executive summary',
    repType_E02: 'Plant portfolio',
    almKicker: 'PROXNOVA / ADMINISTRATION',
    almTitle: 'Alarms',
    almSecActiveFull: 'Active alarms',
    almSecActiveShort: 'Active',
    almSecActiveNote: 'Live alarm monitoring',
    almSecHistFull: 'History',
    almSecHistNote: 'Past alarms and events',
    almSecNotifFull: 'Notifications',
    almSecNotifNote: 'Recipients and notification rules',
    almSecPiFull: 'Status from Pi',
    almSecPiShort: 'Pi',
    almSecPiNote: 'Real-time inverter alarms',
    almCriticalCount: '{n} critical',
    almWarningCount: '{n} warning',
    almColAlarm: 'Alarm',
    almColLevel: 'Level',
    almColActions: 'Actions',
    almStateOn: 'ON (Active)',
    almStateOff: 'OFF (Inactive)',
    almCompany: 'Company',
    almKindCritical: 'Critical alarms',
    almKindWarning: 'Warnings',
    almKindSchedule: 'Notification schedule',
    almSearch: 'Search',
    almSearchPlaceholder: 'Email or role',
    almRole: 'Role',
    almUserActive: 'Active',
    almUserInactive: 'Inactive',
    almNotifyHint: 'Critical alarms and warnings are emailed when an alarm is raised. The schedule stores recipients for planned notifications.',
    almDetailsTitle: 'Alarm details',
    almDuration: 'Duration',
    almAckBy: 'Acknowledged by',
    almAckAt: 'Acknowledged at',
    almResolvedAt: 'Resolved at',
    almLevelInfo: 'INFO',
    devNew: 'New device',
    devViewCards: 'V1 · Devices',
    devViewTable: 'V2 · Table',
    devViewScheme: 'V3 · Scheme',
    devViewAria: 'View version',
    devEyebrow: 'PROXNOVA / DEVICE MONITORING',
    devAcProduction: 'AC PRODUCTION',
    devAcProductionSub: 'Sum of inverters',
    devInvertersStat: 'INVERTERS',
    devInvertersStatSub: 'Devices communicating',
    devOnlineStatSub: 'In inventory',
    devAlarmsStat: 'ALARMS',
    devAlarmsStatSub: 'No communication / alarm',
    devInventory: 'Device inventory',
    devFiltered: 'filtered',
    devInverters: 'inverters',
    devTabAll: 'All',
    devTabInverters: 'Inverters',
    devKindAria: 'Device type',
    devSchemeAria: 'Connection scheme',
    devSchemeTitle: 'Single-line diagram',
    devAcGroups: 'AC groups',
    devLegendEnergy: 'AC/DC energy',
    devLegendComm: 'Communication',
    devBusbar: 'MAIN AC BUSBAR · PARALLEL INVERTERS',
    devLoad: 'LOAD',
    devGrid: 'GRID',
    devMonitoring: 'Modbus TCP · monitoring',
    dashTodayProduction: 'Today\'s production',
    dashWeatherStationSolar: 'Weather Station (Solar)',
    dashDevicesAlarms: 'Devices & alarms',
    dashPlant3dTitle: '3D plant view',
    dashIrradianceGhi: 'Irradiance (GHI)',
    dashTempAmbient: 'Ambient temp.',
    dashTempModule: 'Module temp.',
    dashWind: 'Wind',
    dashHumidityPoa: 'Humidity · POA',
    dashSolarOutput: 'Solar output',
    dashGridExport: 'Grid export',
    dashBuildingSupply: 'Building supply',
    logoutConfirm: 'Are you sure you want to sign out?',
    more: 'More',
    navPanel: 'Panel',
    navMonitor: 'Monitoring',
    navCompany: 'Company',
    companyState: 'Company status',
    allCompanies: 'All companies',
    alarmMessages: 'Latest messages',
    noAlarms: 'No alarms.',
    menu: 'Navigation',
    home: 'Home',
    devices: 'Devices',
    alarms: 'Alarms',
    reports: 'Reports',
    monitoring: 'Monitoring',
    fleetMapAlarm: 'Alarm',
    fleetMapComm: 'Communication',
    fleetMapFresh: 'Freshness',
    fleetMapProd: 'Production',
    fleetMapNone: 'none',
    fleetMapUnknown: 'unknown',
    fleetMapOnline: 'online',
    fleetMapOffline: 'offline',
    fleetMapStale: 'stale',
    fleetMapFreshWord: 'fresh',
    fleetMapProducing: 'producing',
    fleetMapIdle: 'measured zero',
    fleetMapLegend: 'A alarm · C communication (X offline) · F freshness (S stale) · P production. The letters are the state.',
    fleet_overview: 'Fleet map',
    pvFleet: 'PV fleet',
    digitalTwin: 'Digital Twin',
    analysis: 'Analysis',
    analizat: 'Analysis',
    planning: 'Planning',
    control: 'Control',
    companies: 'Companies',
    users: 'Users',
    une: 'Profile',
    navOperations: 'Operations',
    navEnergy: 'Energy',
    navControl: 'Control',
    navAccount: 'Account',
    navInternal: 'Internal tools',
    platformLab: 'Platform Lab',
    shellClock: 'Clock',
    activeCompany: 'Active company',
    edgeLinkOk: 'Edge link ok',
    edgeLinkDown: 'Edge link down',
    operationalScope: 'Operational scope',
    allCompaniesFleet: 'All companies · Fleet scope',
    live: 'LIVE',
    crumbFleet: 'Fleet',
    fleetControlRoom: 'Fleet control room',
    fleetControlSub: 'Live production, alarms and plant triage for the active scope.',
    designInventory: 'Inventory',
    designEnergyAnalysis: 'Energy analysis',
    designAnalysisSub: 'Energy behaviour over time — separate from live operations.',
    designProfileSub: 'Account details',
    designProfileDetails: 'Profile details',
    designProfileHint: 'Account name and email. Role cannot be changed here.',
    designProfileSaved: 'Profile saved.',
    designProfileNeedName: 'Enter a name.',
    designProfileNeedEmail: 'Enter a valid email.',
    designMyAccount: 'My account',
    designAccountMonitor: 'Monitoring & reports',
    designAccountSystem: 'System',
    designLogoutAccount: 'Log out',
    designHourlyBalance: 'Energy balance · today',
    designSelfVsExport: 'Self-consumption vs export',
    designYearOnYear: 'Year-on-year',
    designConsumptionBalance: 'Consumption balance',
    designConsumptionNote: 'Only measured values are shown. Splits that are not metered stay blank.',
    designPending: 'Pending',
    designTariffPending: 'Tariff pending',
    designRevenuePending: 'Revenue analysis is not available yet',
    designBenefitsPending: 'Benefits analysis is not available yet',
    designNeedsMeter: 'Energy analysis needs meter data',
    designNeedsMeterHint: 'Energy meter configured on at least one plant',
    designPlanning: 'Production planning',
    designPlanningSub: 'Hourly actuals against expectation and tomorrow\'s forecast.',
    designActualVsExpected: 'Actual vs expected',
    designHourlyDetail: 'Hourly detail',
    designActual: 'Actual',
    designExpected: 'Expected',
    designVariance: 'Variance',
    designIrradiance: 'Irradiance',
    designWeather: 'Weather',
    designForecastTag: 'Forecast',
    designForecastProduction: 'Forecast production',
    designPeakIrradiance: 'Peak irradiance',
    designExportCsv: 'Export CSV',
    designControl: 'Safety-critical',
    designControlSub: 'Setpoint changes are written to the device and logged against your user.',
    designAlarmContext: 'Alarm context',
    designAlarmDetails: 'Alarm details',
    designAlarmView: 'View',
    alarm: 'Alarm',
    time: 'Time',
    level: 'Level',
    acknowledgedBy: 'Acknowledged by',
    resolve: 'Resolve',
    alarmLevelInfo: 'INFO',
    designAlarmPowerAround: 'Device power around the event',
    designAlarmTechnical: 'Technical detail',
    designOpenDevice: 'Open device',
    designPlant: 'Plant',
    designAlarmDuration: 'Duration',
    designAlarmState: 'State',
    designAlarmActive: 'ACTIVE',
    designAlarmCleared: 'CLEARED',
    designAlarmNotYet: 'not yet',
    designAlarmOngoing: 'ongoing',
    designInvestigate: 'Investigate',
    designCriticalAlarm: 'Critical alarm',
    deviceType: 'Device type',
    plant: 'Plant',
    device: 'Device',
    designWriteAccess: 'Write access granted',
    designStepTarget: 'Target',
    designStepSetpoint: 'Setpoint',
    designStepReview: 'Review',
    designStepAuthorise: 'Authorise',
    designSelectTarget: '1 · Select the target device',
    designDefineSetpoint: '2 · Define the new setpoint',
    designImpactReview: '3 · Impact review',
    designAuthoriseCommand: '4 · Authorise the command',
    designControlMode: 'Control mode',
    designCurrentOutput: 'Current output',
    designRequested: 'Requested',
    designReviewImpact: 'Review impact',
    designContinueAuth: 'Continue to authorisation',
    designTargetDevice: 'Target device',
    designNoControllable: 'No inverters on this data logger.',
    designFleetMap: 'Geographic view',
    fleetMapTitle: 'Fleet map',
    designPlantList: 'Synced plant list',
    administration: 'Administration',
    designAdmin: 'Platform · Administration',
    designAdminSub: 'Users, companies and edge connections.',
    navMonitoring: 'MONITORING',
    systemSettings: 'System settings',
    connections: 'Connections',
    about: 'About',
    aboutApp: 'About this app',
    connectionsHint: 'Connection status and integration documentation.',
    noGateways: 'No gateways registered.',
    configDrift: 'Desired config differs from reported',
    inSync: 'In sync',
    noDevicesOnGateway: 'No devices on this gateway.',
    reportedStatus: 'Reported status',
    protocol: 'Protocol',
    endpoint: 'Endpoint',
    enabled: 'Enabled',
    unknown: 'Unknown',
    loadFailed: 'Failed to load.',
    analysisNoLiveData: 'No measured telemetry for this company. Placeholder statistics are not shown.',
    analysisPeriodUnmeasured: 'Month and year totals are not estimated by multiplying today\'s energy.',
    analysisTariffPending: 'Revenue and benefits require configured tariffs. No billing data is available.',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    passwordChanged: 'Password updated.',
    passwordChangeError: 'Could not change password.',
    passwordMismatch: 'New passwords do not match.',
    languageLabel: 'Language',
    themeLabel: 'Appearance',
    themeDark: 'Dark',
    themeLight: 'Light',

    loginTitle: 'Login',
    loginSubtitle: 'Enter your credentials to continue',
    username: 'Username',
    usernameOrEmailLabel: 'Username or email',
    passwordLabel: 'Password',
    rememberCreds: 'Remember credentials',
    loginBtn: 'Login',
    loggingIn: 'Logging in...',
    signInWithSso: 'Sign in with SSO',
    orContinueWith: 'or',
    developerLabToken: 'Developer lab token',
    hideLabToken: 'Hide lab token',
    labTokenLabel: 'Lab bearer token',
    continueWithLabToken: 'Continue with lab token',
    errorNetwork: 'Connection to server failed.',
    errorLogin: 'Login error. Please try again.',
    toggleThemeLabel: 'Toggle light/dark',

    loading: 'Loading...',
    accessDeniedPage: 'You do not have access to this page',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    apply: 'Apply',
    search: 'Search',
    back: 'Back',
    confirm: 'Are you sure?',
    errorGeneric: 'Error',
    password: 'Password',
    confirmCheck: 'Confirm',
    execute: 'Execute',
    sending: 'Sending...',
    noCompanies: 'No companies',
    selectCompany: 'Select company',
    selectCompanyFirst: 'Select a company.',
    company: 'Company',
    dataLogger: 'Data Logger',
    dataLoggers: 'Data Logger',
    inverter: 'Inverter',
    inverters: 'Inverters',
    energyMeter: 'Energy Meter',
    energyMeters: 'Energy Meters',
    status: 'Status',
    type: 'Type',
    actions: 'Actions',
    online: 'Online',
    offline: 'Offline',
    commInterrupt: 'Comm interrupt',
    catchUpInProgress: 'CATCH-UP IN PROGRESS',
    catchUpInProgressHint: 'Gateway is forwarding buffered offline data. Historical charts are being filled in.',
    gapFilled: 'GAP FILLED',
    gapFilledHint: 'Queue catch-up finished. Late samples were accepted into the historian.',
    deviceCommunicationLost: 'Device communication lost',
    deviceCommunicationLostHint: 'Values below are the last readings received and are not live. Nothing is reported as zero.',
    deviceCommunicationLostCauseHint: 'Edge cannot read Modbus. See the reason above (timeout, exception, unit_id). Values shown are last known, not live.',
    staleLastKnown: 'STALE · LAST KNOWN',
    live: 'LIVE',
    liveTelemetry: 'Live telemetry',
    deviceAlarms: 'Device alarms',
    noDeviceAlarms: 'No alarms recorded for this device.',
    childDevices: 'Child devices',
    communicationHealth: 'Communication health',
    context: 'Context',
    readOnly: 'READ ONLY',
    remoteControl: 'REMOTE CONTROL',
    parent: 'PARENT',
    partial: 'Partial',
    normal: 'Normal',
    active: 'Active',
    inactive: 'Inactive',
    total: 'Total',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    week: 'Week',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    noData: 'No data',

    emPowerFlowTitle: 'Energy flow',
    emPowerFlowPpv: 'Ppv',
    emPowerFlowBattery: 'Discharging power',
    emPowerFlowLoad: 'Load power',
    emPowerFlowGridImport: 'Import',
    emPowerFlowExportTag: 'EXPORT',
    emPowerFlowUnitKw: 'kW',
    emPowerFlowUnitMw: 'MW',

    controlDatalogger: 'Control Datalogger',
    controlSubtitle: 'Select company, data logger and control.',
    selectDataLogger: 'Select data logger',
    start: 'Start',
    stop: 'Stop',
    shutdown: 'Shutdown',
    enable: 'Enable',
    controlLabel: 'Control',
    limitProduction: 'Limit production',
    reactivePower: 'Reactive Power (kVar)',
    powerFactor: 'Power Factor (cosφ)',
    reactiveMode: 'Reactive mode (Q / PF)',
    current: 'Current',
    applyQ: 'Apply Q',
    applyPF: 'Apply PF',
    applyMode: 'Apply mode',
    mode: 'Mode',
    disabled: 'Disabled',
    percent: 'Percent',
    kw: 'kW',
    qKvar: 'Q (kVar)',
    pfCos: 'PF (cosφ)',
    voltVar: 'Volt-Var',
    voltWatt: 'Volt-Watt',
    inverterList: 'Inverter list',
    selectAll: 'Select All',
    noInverters: 'No inverters.',
    selectDataLoggerFirst: 'Select data logger.',

    noCompaniesDash: 'No companies',
    noDataLoggers: 'No Data Loggers',
    addDataLoggerHint: 'Add a data logger for this company',
    co2Today: 'CO2 Today',
    pvNow: 'PV Now',
    pvToday: 'PV Today',
    pvYesterday: 'PV Yesterday',
    todayProfit: "Today's Profit",
    updated: 'Updated',
    justNow: 'just now',
    onGrid: 'ON GRID',
    offGrid: 'OFF GRID',
    flowing: 'flowing',
    production7days: 'Production 7 days (kWh)',
    energyFlow: 'Energy Flow',
    pv: 'PV',
    load: 'Load',
    grid: 'Grid',
    production: 'Production',
    solar: 'Solar',
    pvPower: 'PV Power',
    capacity: 'Capacity',
    dayShort: 'Day',
    monthShort: 'Month',
    yearShort: 'Year',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    totalProduction: 'Total Production',
    urgentAlarms: 'Urgent alarms',
    recentAlarms: 'Recent alarms',
    environmentalImpact: 'Environmental Impact',
    co2TodayLabel: 'CO₂ Today',
    treeEquivalent: 'Tree Equivalent',
    photoUploadSuccess: 'Photo uploaded successfully!',
    photoUploadError: 'Upload error',
    uploadLogo: 'Upload Logo',
    goBack: 'Go Back',
    productionByCompanies: 'Production by companies',
    hold3sForColor: 'Hold 3s on chart to change color',
    weatherStation: 'Weather Station (Solar)',
    radiation: 'Radiation (GHI)',
    tempAmbient: 'Temp. ambient',
    tempModule: 'Temp. module',
    wind: 'Wind',
    humidityPoa: 'Humidity · POA (panel plane)',

    allDevices: 'All Devices',
    inverterBattery: 'Inverter & Battery',
    ems: 'EMS (Energy Meter)',
    addDevice: 'Add Device',
    deviceData: 'Device data',
    noDevices: 'No devices',
    updated1min: 'Updated 1 minute ago',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    detailedParams: 'Detailed Parameters',
    acInfo: 'AC Information',
    analysisGraph: 'Analysis Graph',
    dayLabel: 'Day',
    weekLabel: 'Week',
    monthLabel: 'Month',
    yearLabel: 'Year',
    lifetime: 'Lifetime',
    totalLabel: 'Total',
    co2Label: 'CO₂',
    edit3s: '3s edit',
    editDevice: 'Edit Device',
    typeRequired: 'Type *',
    idRequired: 'ID *',
    select: 'Select...',
    brand: 'Brand',
    selectBrand: 'Select brand...',
    model: 'Model',
    serial: 'Serial',
    ipAddress: 'IP Address',
    dataLoggerRequired: 'Data Logger *',
    powerKw: 'Power (kW) *',
    port: 'Port',
    powerDisplayUnit: 'Display (MW or kW)',
    unitId: 'Unit ID',
    photo: 'Photo',
    uploadPhoto: 'Upload Photo',
    uploadPhotoShort: '📷 Upload Photo',
    selectFile: 'Select file – Upload Photo',
    saving: 'Saving...',
    idOnRaspberry: 'ID on Raspberry',
    power: 'Power',
    noEdgeData: 'No edge data yet.',
    confirmDeleteTitle: 'Confirm delete',
    confirmDeleteDatalogger: 'Are you sure? Data Logger and all connected inverters/energy meters will be deleted.',
    confirmDeleteDevice: 'Are you sure you want to delete this device?',
    deviceDeleted: 'Device deleted!',
    connectionFailed: 'Connection to server failed...',
    deleteError: 'Delete error',
    selectCompanyRequired: 'Select a company!',
    selectDataLoggerRequired: 'Select Data Logger!',
    deviceUpdated: 'Device updated!',
    deviceAdded: 'Device added!',
    photoNotLoggedIn: 'Photo: you are not logged in or token expired. Logout and login again.',
    deviceTypeRequired: 'Device Type *',
    selectType: 'Select type...',
    selectInverter: 'Inverter',
    selectEnergyMeter: 'Energy Meter',
    optional: 'optional',
    serialPathRtu: 'Serial port on Raspberry (RS-485)',
    commHintDatalogger: 'Modbus TCP — data logger IP and port.',
    commHintEnergyMeter: 'Schneider/Siemens: usually Modbus TCP (IP + port 502).',
    commHintChintEnergyMeter:
      'Energy Meter (DTSU666/DSSU666): RS-485 on the Raspberry; set the serial device (e.g. /dev/ttyS1). Data syncs to the Pi like other devices.',
    commHintKacoInverter: 'KACO: with RS-485 set serial_path; for TCP use the logger IP.',
    commHintModbusTcpHuaweiGrowatt: 'Modbus TCP via Data Logger.',
    commHintInverterOtherBrand: 'Modbus TCP — IP and port from configuration.',
    chintSerialPathRequired: 'Energy Meter (RS-485 profile) requires the Raspberry serial port (e.g. /dev/ttyS1).',

    alarmSystem: 'Alarm System',
    activeAlarms: 'Active alarms',
    activeAlarmsList: 'List of active alarms in real time',
    statusFromPi: 'Status from Pi',
    alarmsFromInverters: 'Alarms from inverters (Pi)',
    history: 'History',
    alarmHistory: 'History of previous alarms',
    notifications: 'Notifications',
    registerNotif: 'Register email & SMS for notifications',
    reportsSection: 'Reports',
    alarmReports: 'Detailed reports for alarms',
    activeOnly: 'Active only',
    allDevicesFilter: 'All devices',
    noAlarms: 'No alarms.',
    fromPi: 'From Pi',
    acknowledge: 'Acknowledge',
    alarmRaised: 'Raised',
    alarmAcknowledged: 'Acknowledged',
    alarmReturned: 'Returned',
    alarmCleared: 'Cleared',
    alarmState_active: 'Active',
    alarmState_acknowledged: 'Acknowledged',
    alarmState_returned: 'Returned',
    alarmState_clear: 'Cleared',
    alarmLevelCritical: 'Critical',
    alarmLevelWarning: 'Warning',
    alarmMsgGatewayOffline: 'Gateway offline: {id}',
    alarmMsgGatewayQuota: 'Gateway storage quota: {id}',
    alarmMsgCommLoss: 'Communication loss: {id}',
    alarmMsgCommLossDetail: 'Communication loss: {id} — {detail}',
    alarmStatusFromPi: 'Alarm status from each inverter (latest data from Pi).',
    noInvertersData: 'No inverters or no data.',
    noAlarmList: 'No alarm list.',
    noHistoricalData: 'No historical data.',
    updatedLabel: 'Updated',
    acknowledged: 'Acknowledged',
    email: 'Email',
    emailPlaceholder: 'email@example.com',
    companyOptional: 'Company (optional)',
    all: 'All',
    registerNotifications: 'Register notifications',
    myRegistrations: 'My registrations',
    noRegistrations: 'No registrations.',
    alarmReportsHint: 'Detailed reports for alarms and energy can be generated from the Reports page.',
    openReports: 'Open Reports',
    registerError: 'Registration error.',

    reportsTitle: 'Reports',
    reportsSubtitle: 'Generate and export energy reports',
    generateReport: 'Generate Report',
    totalReports: 'Total Reports',
    daily: 'Daily',
    monthly: 'Monthly',
    yearly: 'Yearly',
    noReportsGenerated: 'No reports generated',
    generateFirstReport: 'Generate the first report to see statistics',
    productionLabel: 'Production',
    pvNowShort: 'PV now',
    consumption: 'Consumption',
    sold: 'Sold',
    revenue: 'Revenue',
    pdf: 'PDF',
    generateNewReport: 'Generate New Report',
    reportType: 'Report Type',
    startDate: 'Start',
    endDate: 'End',
    generating: 'Generating...',
    generate: 'Generate',
    reportGenerated: 'Report generated.',
    reportNoMeasuredData: 'No measured data for this period.',
    reportLoadSeriesError: 'Could not load measured report data.',
    reportAllAuthorized: 'All authorized sites',
    reportSourceMeasured: 'Platform · measured energy',
    reportForecastUnavailable: 'Forecast is not available.',
    reportSourceForecast: 'Forecast · planning',
    reportStudioTomorrow: 'Tomorrow',
    reportKpiDayProduction: 'Day production',
    reportKpiPeakPower: 'Peak power',
    reportKpiInverters: 'Inverters',
    reportKpiCompleteness: 'Completeness',
    reportKpiPeriodTotal: 'Period total',
    reportKpiDailyAvg: 'Daily average',
    reportKpiDays: 'Days',
    reportKpiYearTotal: 'Year total',
    reportKpiPrevYear: 'Previous year',
    reportKpiChange: 'Change',
    reportKpiForecastTotal: 'Forecast total',
    reportKpiHours: 'Hours',
    reportKpiPlant: 'Plant',
    reportKpiStatus: 'Status',
    reportColInverter: 'Inverter',
    reportColProduction: 'Production',
    reportColShare: 'Share',
    reportColDay: 'Day',
    reportColMonth: 'Month',
    reportColThisYear: 'This year',
    reportColLastYear: 'Last year',
    reportColChange: 'Change',
    reportColFlow: 'Flow',
    reportColEnergy: 'Energy',
    reportColHour: 'Hour',
    reportColEmKwh: 'EM kWh',
    reportColAmb: 'Amb °C',
    reportColMod: 'Mod °C',
    reportColWind: 'Wind m/s',
    reportFlowPv: 'PV production',
    reportFlowSelf: 'Self-consumption',
    reportFlowExport: 'Export',
    reportFlowImport: 'Import',
    reportFlowCharge: 'Battery charge',
    reportFlowDischarge: 'Battery discharge',
    reportQueued: 'Report queued. Figures appear only after the CSV is ready.',
    reportNotReady: 'The report is not ready to download.',
    excelColCompany: 'Company',
    excelColTag: 'Measurement',
    excelColDirection: 'Direction',
    excelColUnit: 'Unit',
    excelColMeasured: 'Measured (kWh)',
    excelColEstimated: 'Estimated (kWh)',
    excelColAccepted: 'Accepted rows',
    excelColEstimatedRows: 'Estimated rows',
    excelDirProduction: 'Production',
    excelDirExport: 'Export',
    excelDirImport: 'Import',
    excelDirConsumption: 'Consumption',
    excelDirOther: 'Other',
    permGroupCommands: 'Commands',
    permGroupCompanies: 'Companies',
    permGroupConfig: 'Configuration',
    permGroupDevices: 'Devices',
    permGroupEnergy: 'Energy',
    permGroupGateways: 'Gateways',
    permGroupHistory: 'History',
    permGroupReports: 'Reports',
    permGroupSites: 'Sites',
    permGroupTags: 'Tags',
    permGroupTenants: 'Tenants',
    permGroupUsers: 'Users',
    'perm.commands:request': 'Request remote commands',
    'perm.commands:approve': 'Approve remote commands',
    'perm.companies:read': 'List and read companies',
    'perm.companies:write': 'Create, update, and delete companies',
    'perm.config:draft': 'Create draft configuration revisions',
    'perm.config:publish': 'Publish desired configuration to a gateway',
    'perm.config:read': 'Read configuration revisions and gateway sync state',
    'perm.config:report': 'Record a gateway reported configuration state',
    'perm.devices:read': 'Read devices',
    'perm.devices:write': 'Write devices',
    'perm.energy:read': 'Read energy counter definitions, deltas, and issues',
    'perm.energy:write': 'Create, update, and delete energy counter definitions',
    'perm.gateways:read': 'Read gateways',
    'perm.gateways:write': 'Write gateways',
    'perm.history:read': 'Read historical telemetry readings',
    'perm.reports:request': 'Request asynchronous reports',
    'perm.sites:read': 'Read sites',
    'perm.sites:write': 'Write sites',
    'perm.tags:read': 'Read tags',
    'perm.tags:write': 'Write tags',
    'perm.tenants:read': 'List and read tenants',
    'perm.tenants:write': 'Create and update tenants',
    'perm.users:read': 'List tenant users and roles',
    'perm.users:write': 'Create, update, and disable tenant users',
    reportNoMeasured: 'No accepted measurements in this period. A zero was not invented.',
    reportDownloadCsv: 'CSV',
    reportStatusQueued: 'Queued',
    reportStatusRunning: 'Calculating',
    reportStatusCompleted: 'Ready',
    reportStatusFailed: 'Failed',
    reportStatusRejected: 'Rejected',
    reportStatusExpired: 'Expired',
    reportError: 'Error generating report.',
    reportAllCompanies: 'All companies (single combined report)',
    reportAllCompaniesMyAccess: 'All companies I have access to',
    reportFleetGenerated: 'Combined report for all companies was generated.',
    reportFleetCompanyLabel: 'All companies',
    reportFleetPdfSectionsHint: 'PDF with one section per company',
    reportFleetByCompanyMwh: 'Production by company (MWh)',
    reportFleetTableCompany: 'Company',
    reportFleetTableMwh: 'Production (MWh)',
    reportFleetTableTotal: 'Total',
    reportGridExportKwhLabel: 'Export',
    reportGridImportKwhLabel: 'Import',
    reportFleetTableExportKwh: 'Export',
    reportFleetTableImportKwh: 'Import',
    pvFleetAllCompanies: 'All',
    pvFleetEnergyShort: 'All companies',
    pvFleetBackToDashboard: 'Back to dashboard',
    reportsBulkAllOk: '{{n}} reports were generated (one per company).',
    reportsBulkNone: 'No reports were generated.',
    reportsBulkPartialOk: 'Generated {{ok}} of {{total}} reports; some companies failed.',
    deleteReport: 'Delete',
    deleteReportDialogTitle: 'Delete report',
    confirmDeleteReport: 'Are you sure you want to delete this report?',
    reportDeleted: 'Report deleted.',
    reportDeleteError: 'Error deleting report.',
    reportsFilterListPeriod: 'Filter by report period',
    reportsSearchPlaceholder: 'Search (type, company, dates…)',
    reportsClearFilters: 'Clear filters',
    reportsNoFilterResults: 'No reports match the filters.',
    dailyReport: 'Daily',
    weeklyReport: 'Weekly',
    monthlyReport: 'Monthly',
    yearlyReport: 'Yearly',
    companyLabel: 'Company',
    energyReport: 'Energy Report',
    period: 'Period',
    metric: 'Metric',
    value: 'Value',
    totalProductionLabel: 'Total Production',
    totalConsumption: 'Total Consumption',
    energySold: 'Energy Sold',
    totalRevenue: 'Total Revenue',
    alarmActive: 'Active',
    alarmInactive: 'In Active',
    monitoringTitle: 'Monitoring – Latest data',
    checkingConnection: 'Checking connection...',
    monitoringNotConnected: 'The regional hub is not connected',
    monitoringNotConnectedHint: 'The regional real-time data link is temporarily unavailable.',
    sshTunnelHint: 'On VPS run the tunnel:',
    monitoringRegionalLinkBanner:
      'The regional quick-link is not responding. The map and lists below load from the main server; PV / today values may update more slowly.',
    inverterLastRead: 'Inverter (last reading)',
    dataloggerLastRead: 'Data logger (last reading)',
    energyMeterLastRead: 'Energy meter (last reading)',
    alarmsLast10: 'Alarms (last 10)',
    deviceStatus: 'Device status',
    dailyEnergy: 'Daily energy (kWh)',
    totalEnergy: 'Total energy',

    energyManagement: 'Energy Management',
    energy: 'Energy',
    energyAnalysis: 'Energy Analysis',
    consumptionAnalysis: 'Consumption Analysis',
    revenueAnalysis: 'Revenue Analysis',
    benefits: 'Benefits',
    selectDates: 'Select Dates',
    energyBalance: 'Energy Balance',
    selfConsumption: 'Self-Consumption',
    exportLabel: 'Export',
    selfSufficiency: 'Self-Sufficiency',
    buyFromGrid: 'Buy from Grid',
    supply: 'Supply (kW)',
    usage: 'Usage',
    loads: 'Loads',
    network: 'Network',
    solarGen: 'Solar',
    generation: 'Generation',
    imported: 'Imported',
    pvProduced: 'PV Produced',
    discharged: 'Discharged',
    exported: 'Exported',
    consumed: 'Consumed',
    charged: 'Charged',
    selectPeriod: 'Select Period',
    fromDate: 'From Date',
    toDate: 'To Date',

    productionPlanning: 'Production Planning',
    selectDate: 'Date (calendar for history)',
    selectCompanyForData: 'Select a company to view data.',
    selectDateAndSearch: 'Select a date (or Yesterday) and click Search.',
    clickSearchHint: 'Click Search to fetch data for {date}.',
    loadingData: 'Loading data...',
    noEnergyMeters: 'No energy meters for this company.',
    weatherHint: 'Weather data (GHI, temp, wind) will appear when you install weather station.',
    hour: 'Hour',
    emProduction: 'EM Production (kWh)',
    dataloggerKwh: 'Datalogger (kWh)',
    difference: 'Difference (EM−DL)',
    radiationGhi: 'Radiation (GHI) W/m²',
    tempAmbientC: 'Temp. ambient °C',
    tempModuleC: 'Temp. module °C',
    windSpeed: 'Wind (m/s)',
    weatherOnlyHint: 'Weather only (Open-Meteo). Production will appear when you install energy meter.',
    emDlHint: 'EM = Energy Meter (pi_energy_meter_readings). DL = Datalogger (pi_datalogger_readings, energy_total_mwh). Diff = EM − DL (positive = meter more than datalogger, negative = datalogger more).',
    data: 'Date',
    productionAndWeatherHourly: 'Production and weather by hour (05:00–20:00)',
    planningForecastSubtitle: 'Forecast (similar-days); production = model, weather = forecast + station',
    planningLabEstimateTitle: 'Lab estimate — not an operational forecast',
    planningLabEstimateBody: 'This is a clear-sky irradiance ceiling (Haurwitz). Clouds are not modeled. Production is not estimated without an approved capacity. This screen is off in production.',
    planningCoordinatesMissing: 'Plant coordinates are missing. Without them the clear-sky ceiling is not calculated.',
    planningNoSites: 'This company has no active site.',
    planningTimezoneMissing: 'The site has no timezone.',
    planningMixedTimezones: 'This company has sites in more than one timezone. Request them separately.',
    planningForecastDisabled: 'The lab estimate is disabled.',
    planningGenerated: 'Planning was generated.',
    planningSiteForbidden: 'You cannot see this company\'s sites.',
    reportsDisabledHint: 'Reports are disabled on the server (PLATFORM_API_REPORTS_ENABLED).',
    reportForbidden: 'Report generation is not allowed (403).',
    reportCategoryUnavailable: 'This category is not available yet — use Production.',
    clearSkyCeiling: 'Clear-sky ceiling (W/m²)',
    weatherLabSeed: 'Lab weather (not a station)',
    weatherStation: 'Weather station',
    planningEmptyHint:
      'For history: pick a date (or Yesterday) and click Search. For the lab ceiling: click Tomorrow. The date is the next civil day in the site timezone, not +24 hours.',
    planningForecastExportTitle: 'Planning — Forecast',
    planningHistoryExportTitle: 'Planning — Export',
    forecastSimilarDays: 'Similar days',
    forecastDailyTotal: 'Daily total (forecast)',

    companiesTitle: 'Companies',
    companiesSubtitle: 'Manage companies and data',
    setDashboardPhoto: 'Set dashboard photo for all',
    setting: 'Setting...',
    addCompany: '+ Add Company',
    totalCompanies: 'Total Companies',
    noCompaniesRegistered: 'No companies registered',
    addFirstCompany: 'Add the first company to get started',
    logo: 'Logo',
    companyName: 'Company name',
    address: 'Address',
    phone: 'Phone',
    website: 'Website',
    uniqueNr: 'Unique Nr',
    vatNr: 'VAT Nr',
    hold3sForLogo: 'Hold 3 seconds to upload logo (PNG)',
    editCompany: 'Edit Company',
    addNewCompany: 'Add New Company',
    dashboardPhoto: 'Dashboard photo (optional)',
    dashboardPhotoHint: 'Each company has its own photo on the first page (dashboard)...',
    selectDashboardPhoto: 'Select dashboard photo',
    companyNameRequired: 'Company name *',
    selectPhoto: 'Select a PNG image...',
    selectImage: 'Select Image',
    pngOnly: 'PNG files only (.png).',
    confirmDeleteCompany: 'Are you sure you want to delete this company?',
    confirmSeedDashboardPhotos: 'Set dashboard photo for all companies? You can change it later from the Edit Company modal.',
    logoUploaded: 'Logo uploaded successfully!',
    uploadError: 'Upload error',
    imagesOnly: 'Only images allowed: PNG, JPG, JPEG, WEBP.',
    dashboardPhotoUploaded: 'Dashboard photo uploaded successfully!',
    companySaveError: 'Error saving company.',
    deleteCompanyError: 'Error while deleting the company.',

    usersTitle: 'Users',
    addUser: '+ Add User',
    ensureBackendRunning: 'Make sure the backend (FastAPI) is running on port 8000.',
    tryAgain: 'Try again',
    closeMessage: 'Close',
    closeMessageAria: 'Close message',
    name: 'Name',
    usernameLabel: 'Username',
    emailLabel: 'Email',
    companyLabelUsers: 'Company',
    editUser: 'Edit User',
    addNewUser: 'Add New User',
    fullName: 'Full Name',
    fullNameAlt: 'Full Name',
    passwordOptional: 'Password (optional)',
    role: 'Role',
    navigation: 'Navigation',
    selectCompanyUsers: 'Select Company',
    allowedNavigation: 'Allowed Navigation',
    none: 'None',
    companiesCount: 'companies',
    pages: 'pages',
    allOption: 'All',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    saveError: 'Error saving.',
    deleteUserError: 'Error deleting.',

    activePower: 'Active Power',
    reactivePower: 'Reactive Power',
    powerFactor: 'Power Factor (PF)',
    energyToday: 'Energy (Today)',
    totalEnergyYield: 'Total Energy Yield',
    fault: 'Fault',
    standby: 'Standby',
    deviceInfo: 'Device Information',
    modelLabel: 'Model',
    ipLabel: 'IP',
    portLabel: 'Port',
    totalInverter: 'Total Inverter',
    details: 'Details',
    realTime: 'Real Time',

    inverterNotFound: 'Inverter not found',
    inverterDetails: 'Inverter Details',
    statusAndEnergy: 'Status & Energy',
    power: 'Power',
    pvVoltage: 'PV Voltage',
    pvCurrent: 'PV Current',
    gridAndPhase: 'Grid & Phase',
    system: 'System',
    pvPower: 'PV Power',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    monthlyPvYield: 'Monthly PV Yield',
    energyAnalysis: 'Energy Analysis',
    details: 'Details',
    realTime: 'Real Time',
    alarms: 'Alarms',
    realtimeCurve: 'Real-time Curve',
    deviceStatus: 'Device status',
    energyYieldCurrentDay: 'Energy yield of current day',
    totalEnergyYield: 'Total energy yield',
    reducedCo2Emission: 'Reduced CO2 emission',
    dcPower: 'DC power',
    activePower: 'Active power',
    reactivePower: 'Reactive power',
    powerFactor: 'Power factor',
    gridAbBcCaVoltage: 'Grid AB/BC/CA voltage',
    gridAbcPhaseCurrent: 'Grid A/B/C phase current',
    todayPeakActivePower: "Today's peak active power",
    gridFrequency: 'Grid frequency',
    locking: 'Locking',
    cabinetTemperature: 'Cabinet temperature',
    startupTime: 'Startup time',
    shutdownTime: 'Shutdown time',
    collectDspData: 'Collect DSP data',
    activePowerAdjustment: 'Active power adjustment',
    reactivePowerAdjustment: 'Reactive power adjustment',
    pv18Voltage: 'PV1-8 voltage',
    pv916Voltage: 'PV9-16 voltage',
    pv1724Voltage: 'PV17-24 voltage',
    pv2528Voltage: 'PV25-28 voltage',
    pv18Current: 'PV1-8 current',
    pv916Current: 'PV9-16 current',
    pv1724Current: 'PV17-24 current',
    pv2528Current: 'PV25-28 current',
    allDevices: 'All Devices',
    inverterTab: 'Inverter',
    emsTab: 'EMS',
    noAlarmsInverter: 'No alarms.',

    energyMeterNotFound: 'Energy Meter not found',
    alarmHistoryLabel: 'Alarm History',
    activeAlarmsLabel: 'Active Alarms',
    noActiveAlarms: 'No active alarms.',
    noAlarms: 'No alarms.',
    activePowerReal: 'Active Power',
    todayEnergy: 'Today Energy',
    monthlyEnergy: 'Monthly Energy (1–31)',
    totalEnergyLabel: 'Total Energy',
    emKpiActivePower: 'Active power',
    emKpiToday: 'Today',
    emKpiMonth: 'Month',
    emKpiPowerFactor: 'Power factor',
    emEnergyDirection: 'Energy direction',
    emFourQuadrant: '4-quadrant',
    emSiteEnergy: 'Site energy',
    emGridImport: 'Grid import',
    emGridExport: 'Grid export',
    emPhases: 'Phases',
    emHistory: 'History',
    emImportExportCounters: 'Import / export counters',
    emGridImportTotal: 'Grid import · total',
    emGridExportTotal: 'Grid export · total',
    emImportToday: 'Import today',
    emReactiveImport: 'Reactive import',
    emReactiveExport: 'Reactive export',
    emUpdatedPrefix: 'updated',
    emActiveCount: 'active',
    emExportActivePower: 'Export / active power',
    emMonitoring: 'MONITORING',
    emTabDetails: 'Details',
    emTabRealtime: 'Realtime',
    emTabAlarms: 'Alarms',
    emTabInOut: 'I/O',
    emPeriodDay: 'Day',
    emPeriodMonth: 'Month',
    emPeriodYear: 'Year',
    emPeriodTotal: 'Total',
    emDateLabel: 'Date',
    chintCardProduction: 'Production',
    chintCardLoad: 'Load',
    chintCardImport: 'Import',
    chintCardExport: 'Export',
    meterDetails: 'Meter Details',
    energyAnalysisLabel: 'Energy Analysis',
    emChartTimeLabel: 'Time',
    emSeriesSystemProduction: 'System production',
    emSeriesSolarProduction: 'Solar production',
    emSeriesLoadConsumption: 'Load consumption',
    emSeriesSelfConsumption: 'Self-consumption',
    emSeriesExportToGrid: 'Export to grid',
    emSeriesImportFromGrid: 'Import from grid',
    emSeriesCharged: 'Charged',
    emSeriesDischarged: 'Discharged',
    emSystemProductionTotal: 'System production:',
    emLoadConsumptionTotal: 'Load consumption:',
    inOut: 'IN-OUT',
    photoUpload: 'Upload Photo',
    photoUploadFor: 'Upload Photo for',
    selectPhoto: 'Select Photo',
    exportLabel: 'Export',
    totalLabel: 'Total',
    emSectionPower: 'Power',
    emSectionEnergy: 'Energy',
    emSectionVoltage: 'Voltage',
    emSectionCurrent: 'Current',
    emSectionFrequency: 'Frequency',
    emSectionDemand: 'Demand (Peak)',
    emSectionAdvanced: 'Advanced',
    digitalIO: 'Digital I/O',
    inputs: 'Inputs',
    outputs: 'Outputs (hold >5s to write)',
    figureScheme: 'Figure / Scheme',
    verifyPayload: 'Verify payload (raw from API)',
    writeDO: 'Write DO1/DO2',
    confirmStopStart: 'Are you sure? Turn off or on?',
    send: 'Send',

    detailedParameters: 'Detailed Parameters',
    pvInfo: 'PV Information',
    voltage: 'Voltage(V)',
    currentLabel: 'Current(A)',
    powerLabel: 'Power(kW)',
    frequency: 'Frequency(H...',
    gridInfo: 'Grid Information',
    gridStatus: 'Grid Status',
    dailyFeedIn: 'Daily feed-in energy',
    totalFeedIn: 'Total feed-in energy',
    dailyPurchased: 'Daily purchased energy',
    totalPurchased: 'Total purchased energy',
    feedInPower: 'Feed-in power',
    purchasedPower: 'Purchased power',
    loadInfo: 'Load Information',
    gridPower: 'Grid Power',
    acVoltage: 'AC Voltage',
    acCurrent: 'AC Current',
    acFrequency: 'AC Frequency',
    loadPower: 'Load Power',
    loadCurrent: 'Load Current',
    pv1Voltage: 'PV1 Voltage',
    pv1Current: 'PV1 Current',
    pv2Voltage: 'PV2 Voltage',
    pv2Current: 'PV2 Current',
    dailyLoadConsumption: 'Daily Load Consumption',
    totalLoadConsumption: 'Total Load Consumption',
    totalLoadPower: 'Total Load Power',
    gridLoadPower: 'Grid Load Power',
    epsLoadPower: 'EPS Load Power',

    plantCondition: 'Plant status',
    dlInputPowerDc: 'Input power / DC',
    dlGridPhaseCurrents: 'Grid phase currents',
    dlLockStatus: 'Grid connection status',
    dlAcOutput: 'AC output',
    dlEfficiency: 'Efficiency',
    dlPhaseL1: 'L1',
    dlPhaseL2: 'L2',
    dlPhaseL3: 'L3',
    dlLink: 'Link',
    dlProtocol: 'Protocol',
    dlNoComm: 'Devices without communication',
    dlAvailability: 'Availability',
    dlLoad: 'Load',
    dlReactiveAdjustmentLimits: 'Reactive Adjustment Limits',
    dlActiveAdjustmentLimits: 'Active Adjustment Limits',
    dlPvReactiveLimits: 'PV Reactive Limits',
    dlEssReactiveLimits: 'ESS Reactive Limits',
    dlPvActiveLimit: 'PV Active Limit',
    dlEssPeaks: 'ESS Peaks',
    dlApiOverrideStatuses: 'API Override Statuses',
    dlRemoteScheduling: 'Remote Scheduling',
    dlKpi: 'KPI',
    dlActivePower: 'Active Power',
    dlDcPower: 'DC Power',
    dlInputPowerKw: 'Input Power (kW)',
    dlDcCurrentA: 'DC Current (A)',
    dlGridAPhaseCurrent: 'Grid A Phase Current (A)',
    dlGridBPhaseCurrent: 'Grid B Phase Current (A)',
    dlGridCPhaseCurrent: 'Grid C Phase Current (A)',
    dlLockStatusLabel: 'Lock Status',
    dlReducedCo2Kg: 'Reduced CO₂ (kg)',
    dlMaxReactiveAdj: 'Max. reactive adjustment (kVar)',
    dlMinReactiveAdj: 'Min. reactive adjustment (kVar)',
    dlMaxActiveAdj: 'Max. active adjustment (kW)',
    dlMinActiveAdj: 'Min. active adjustment (kW)',
    dlPvReactiveMax: 'Highest reactive PV (kVar)',
    dlPvReactiveMin: 'Lowest reactive PV (kVar)',
    dlEssReactiveMax: 'Highest reactive ESS (kVar)',
    dlEssReactiveMin: 'Lowest reactive ESS (kVar)',
    dlPvActiveMax: 'Highest active PV (kW)',
    dlEssDischargeMax: 'ESS Max Discharge (kW)',
    dlEssChargeMax: 'ESS Max Charge (kW)',
    dlApiActiveOverride: 'API active override (lower priority)',
    dlApiReactiveOverride: 'API reactive override (lower priority)',
    dlRemoteSchedP: 'Remote scheduling (P)',
    dlRemoteSchedQ: 'Remote scheduling (Q)',

    // SCADA-L02 operator strings (dashboard / control / fleet / planning)
    noDataToday: 'No data for today',
    noDataLoggersForCompany: 'No Data Logger for this company',
    noEnergyMetersForCompany: 'No Energy Meter for this company',
    noInvertersForCompany: 'No Inverter for this company',
    treesUnit: 'trees',
    treesUnitK: 'K trees',
    tonUnit: 'ton',
    kgUnit: 'kg',
    onlineCountLabel: 'Online',
    offlineCountLabel: 'Offline',
    capacityAbbrev: 'cap.',
    timeLabel: 'Time',
    previousDayAria: 'Previous day',
    nextDayAria: 'Next day',
    companyPagesAria: 'Company pages',
    fleetOutputEyebrow: 'Fleet Output',
    liveOutput: 'Live output',
    totalCapacityLabel: 'Total capacity',
    mwNowLabel: 'MW · NOW',
    ofCapacityPct: '% of {cap} MW',
    hybridEnergyAnalysis: 'Hybrid analysis',
    hybridEnergyAnalysisHint: 'Off = import/export only. On = solar, load, battery with legend.',
    controlFailClosedBanner:
      'Only the plant active-power limit is written to the SmartLogger. Start, Stop, Enable and Shutdown stay off. The password is checked before the command is sent. Success means the register was read back.',
    platformCommandProbe: 'Platform command probe',
    platformProbing: 'Probing…',
    solarEssTitle: 'Solar Energy Storage System',
    searchByLocation: 'Search by location...',
    noCompanyFound: 'No company found',
    mapLabel: 'Map',
    energyProducedToday: 'Energy produced today',
    totalFromAllEnergyMeters: 'Total from all energy meters',
    fromAllEnergyMeters: 'From all energy meters',
    monthlyTrend: 'Monthly trend',
    productionByCompany: 'Production by company',
    producingNow: 'Producing now',
    pvNowAllCompaniesSum: 'PV now — sum of all companies',
    totalCompaniesCount: 'Total companies',
    pvNowTotal: 'PV now (total)',
    energyProduced: 'Energy produced',
    fleetPower: 'Fleet power',
    monthlyEnergy: 'Monthly energy',
    monthToDateHint: '1 → today (month)',
    installed: 'Installed',
    realtimeCurve: 'Real-time curve',
    periodDayShort: 'Day',
    periodMonthShort: 'Month',
    periodYearShort: 'Year',
    periodTotal: 'Total',
    periodLifetime: 'Lifetime',
    updatedAt: 'Updated',
    exportColCompany: 'Company',
    exportColDate: 'Date',
    exportColMeter: 'Energy Meter',
    exportColHour: 'Hour',
    exportColProductionKwh: 'Production (kWh)',
    exportColGhi: 'Radiation GHI (W/m2)',
    exportColTempAmbient: 'Temp. Ambient (C)',
    exportColTempModule: 'Temp. Module (C)',
    exportColWind: 'Wind (m/s)',
    digitalTwinTitle: 'PV-01 · Solar Plant Digital Twin',
    digitalTwinSubtitle: 'SITE 04 / 66 kWp ARRAY / 11 kV UTILITY TIE',
    digitalTwinPvKw: 'PV kW',
    digitalTwinBatteryKw: 'Battery kW',
    digitalTwinGridKw: 'Grid kW',
    digitalTwinLoadKw: 'Load kW',
    digitalTwinLive: 'Live',
    digitalTwinAutoCycle: 'Auto cycle',
    digitalTwinManual: 'Manual',
    digitalTwinPowerFlowState: 'Power flow state',
    digitalTwinSequence: 'Sequence',
    digitalTwinAutoCycleAll: 'Auto cycle all states',
    digitalTwinScenario: 'Scenario',
    digitalTwinTrackingLive: 'Tracking real-time telemetry.',
    digitalTwinBatterySoc: 'Battery state of charge',
    digitalTwinMetering: 'Metering',
    digitalTwinDcBus: 'DC bus',
    digitalTwinAcBus: 'AC bus',
    digitalTwinFrequency: 'Frequency',
    digitalTwinPowerFactor: 'Power factor',
    digitalTwinSelfConsumption: 'Self-consumption',
    digitalTwinStatus: 'Status',
    digitalTwinTwin: 'Twin',
    digitalTwinControlsHint: 'Orbit: drag · Zoom: wheel · Pan: right-drag.',
    digitalTwinLegendSolar: 'Solar generation',
    digitalTwinLegendBattery: 'Battery discharge',
    digitalTwinLegendGrid: 'Grid import',
    digitalTwinLegendLoad: 'Site load',
    digitalTwinLegendOff: 'De-energised',
    digitalTwinLiveTelemetry: 'LIVE TELEMETRY',
    digitalTwinDemoSequence: 'DEMO SEQUENCE',
    digitalTwinAlarmInvOk: 'Inverter INV-01 · running',
    digitalTwinAlarmCbOk: 'Combiner CB-01 · 6/6 strings',
    digitalTwinAlarmStringWarn: 'String 3 · −4% yield deviation',
    digitalTwinAlarmEssOk: 'ESS BMS · balanced',
    digitalTwinAlarmUtilityOk: 'Utility tie · synchronised',
    digitalTwinStateSolarLoad: 'Solar → Load',
    digitalTwinStateSolarBatt: 'Solar → Battery',
    digitalTwinStateSolarGrid: 'Solar → Grid',
    digitalTwinStateGridLoad: 'Grid → Load',
    digitalTwinStateBattLoad: 'Battery → Load',
    digitalTwinStateGridBatt: 'Grid → Battery',
    digitalTwinStateSolarBattLoad: 'Solar → Battery → Load',
    digitalTwinNoteSolarLoad: 'Array output matched to site demand. Battery idle, no grid exchange.',
    digitalTwinNoteSolarBatt: 'Surplus generation charging the ESS. Site demand off-shift.',
    digitalTwinNoteSolarGrid: 'Battery full, load light — surplus exported through the 11 kV tie.',
    digitalTwinNoteGridLoad: 'Night operation. Array offline, ESS held at reserve, grid carries the site.',
    digitalTwinNoteBattLoad: 'Peak-shaving discharge. Grid import held at zero during tariff peak.',
    digitalTwinNoteGridBatt: 'Off-peak recharge from the grid ahead of the morning peak.',
    digitalTwinNoteSolarBattLoad: 'Array serving the site and charging the ESS simultaneously.',
    controlConfirmStop: 'Are you sure? Stop the selected inverters?',
    controlConfirmStart: 'Are you sure? Start the selected inverters?',
    controlConfirmShutdown: 'Are you sure? Shut down the whole plant?',
    controlConfirmEnable: 'Are you sure? Enable / start the plant?',
    controlConfirmLimitDisable: 'Are you sure? Remove the production limit?',
    controlConfirmLimitPercent: 'Are you sure? Apply a % production limit?',
    controlConfirmLimitKw: 'Are you sure? Apply a kW production limit?',
    controlConfirmReactive: 'Are you sure? Set reactive power Q (kVar)?',
    controlConfirmPf: 'Are you sure? Set Power Factor (cosφ)?',
    controlConfirmQMode: 'Are you sure? Change the reactive control mode?',
    controlSelectCompanyDl: 'Select company and data logger.',
    controlInvalidPercent: 'Enter a valid % (0–100).',
    controlInvalidKw: 'Enter a valid kW value.',
    controlInvalidKvar: 'Enter a valid kVar value (e.g. -50, 0, +50).',
    controlInvalidPf: 'Enter a valid PF (0.80–1.00 or -1.00–1.00).',
    controlInvalidMode: 'Select a valid mode.',
    'cmdOutcome.executed': 'Executed and verified.',
    'cmdOutcome.pendingApproval': 'Waiting for approval by another person. Nothing has been sent to the plant yet.',
    'cmdOutcome.received': 'Accepted by the gateway; awaiting execution.',
    'cmdOutcome.dispatched': 'Command sent to the gateway.',
    'cmdOutcome.approved': 'Command approved; sending to the gateway.',
    'cmdOutcome.requested': 'Command registered (requested).',
    'cmdOutcome.rejected': 'Command rejected.',
    'cmdOutcome.cancelled': 'Command cancelled.',
    'cmdOutcome.failedOrExpired': 'Command {status}.',
    'cmdOutcome.statusFailed': 'failed',
    'cmdOutcome.statusExpired': 'expired',
    'cmdOutcome.unknown': 'Unknown command status: {status}.',
    'cmdOutcome.reasonPrefix': 'Reason: {reason}',
    'cmdOutcome.idPrefix': 'ID: {id}',
    'cmdOutcome.expiresAt': 'Expires: {time}',
    'cmdOutcome.register': 'Register: {register}',
    'cmdOutcome.address': 'Address: {address}',
    'cmdOutcome.valueWritten': 'Written: {values}',
    'cmdOutcome.valueRead': 'Read: {values}',
    'cmdReason.approval_timeout': 'Approval window expired without a response.',
    'cmdReason.no_edge_ack': 'Gateway did not acknowledge within ~30 s.',
    'cmdReason.no_execution_confirmation': 'No execution confirmation within ~120 s.',
    'cmdReason.edge_commands_disabled': 'Commands are disabled on the gateway.',
    'cmdReason.unsupported_command': 'Command type is not supported on the gateway.',
    'cmdReason.replay': 'Command rejected (replay / duplicate).',
    'cmdReason.signature_invalid': 'Command signature is invalid.',
    'cmdReason.expired': 'Command expired before execution.',
    'cmdReason.commands_disabled': 'Platform commands are disabled.',
    'cmdReason.self_approval_forbidden': 'You cannot approve your own command — someone else must approve.',
    'cmdReason.invalid_state': 'Command state does not allow this action.',
    'cmdReason.invalid_credentials': 'Password is incorrect.',
    'cmdReason.password_check_unavailable': 'Password verification is unavailable.',
    'cmdStep.requested': 'Requested',
    'cmdStep.approval': 'Approval',
    'cmdStep.dispatched': 'Sent to gateway',
    'cmdStep.received': 'Received by gateway',
    'cmdStep.executed': 'Executed & verified',
    'cmdUi.lifecycleTitle': 'Command status',
    'cmdUi.refreshStatus': 'Refresh status',
    'cmdUi.pendingTitle': 'Pending approvals',
    'cmdUi.pendingEmpty': 'No commands awaiting approval.',
    'cmdUi.recentTitle': 'Recent commands',
    'cmdUi.recentEmpty': 'No command history yet.',
    'cmdUi.requestedBy': 'Requested by',
    'cmdUi.timeLeft': 'Time left',
    'cmdUi.approveAction': 'Approve',
    'cmdUi.rejectAction': 'Reject',
    'cmdUi.cancelAction': 'Cancel',
    'cmdUi.approveTitle': 'Confirm approval',
    'cmdUi.rejectTitle': 'Reject command',
    'cmdUi.rejectReasonLabel': 'Rejection reason',
    'cmdUi.rejectReasonPlaceholder': 'Enter reason…',
    'cmdUi.rejectReasonRequired': 'Rejection reason is required.',
    'cmdUi.selfApprovalForbidden': 'You cannot approve your own command — someone else must approve.',
    'cmdUi.invalidCredentials': 'Password is incorrect.',
    'cmdUi.approveSuccess': 'Command approved and dispatched.',
    'cmdUi.approveFailed': 'Approval failed.',
    'cmdUi.rejectSuccess': 'Command rejected.',
    'cmdUi.rejectFailed': 'Rejection failed.',
    'cmdUi.cancelSuccess': 'Command cancelled.',
    'cmdUi.cancelFailed': 'Cancellation failed.',
    'cmdUi.secondsLeft': '{sec} s',
    'cmdUi.minutesLeft': '{min} min {sec} s',
    'cmdUi.expiredNow': 'Expired',
  },
};
